(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["flavour-qr"] && !Shopify.designMode) return;
  try {
    
function initHJQRAccordions(root){if(root.dataset.qrAccordionReady)return;root.dataset.qrAccordionReady='true';const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  root.querySelectorAll('.hj-qr-accordions details').forEach(detail=>{
    const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
    let animation=null,expanded=detail.open;
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=detail.getBoundingClientRect().height;
      expanded=!expanded;
      animation?.cancel();
      detail.open=true;
      detail.style.height='auto';
      const border=parseFloat(getComputedStyle(detail).borderTopWidth)+parseFloat(getComputedStyle(detail).borderBottomWidth);
      const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
      summary.setAttribute('aria-expanded',String(expanded));
      panel.inert=!expanded;
      const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
      if(reduced.matches){finish();return}
      animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});
      animation.onfinish=finish;
    });
  });
}
document.querySelectorAll('.hj-qr').forEach(initHJQRAccordions);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.hj-qr').forEach(initHJQRAccordions));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hard-jelly-footer"] && !Shopify.designMode) return;
  try {
    
function initHJFooter(root){
const form=root.querySelector('.hj-footer__form');
const success=root.querySelector('.hj-footer__success');
const fields=root.querySelector('.hj-footer__fields');
if(form&&!form.dataset.signupReady){
form.dataset.signupReady='true';
form.addEventListener('submit',()=>{try{sessionStorage.setItem('hj-newsletter-submitted','1')}catch(e){}});
if(success&&fields){
let submitted=false;
try{submitted=sessionStorage.getItem('hj-newsletter-submitted')==='1';sessionStorage.removeItem('hj-newsletter-submitted')}catch(e){}
const nav=performance.getEntriesByType?.('navigation')?.[0];
const isReload=nav?.type==='reload';
if(isReload||!submitted){success.hidden=true;fields.classList.remove('hj-footer__fields--success')}
}
}
root.querySelectorAll('.hj-footer-social').forEach(a=>{
if(a.dataset.ready)return;a.dataset.ready='true';
const enter=()=>a.classList.remove('is-returning');
const leave=()=>{a.classList.remove('is-returning');void a.offsetWidth;a.classList.add('is-returning')};
a.addEventListener('mouseenter',enter);a.addEventListener('focus',enter);
a.addEventListener('mouseleave',leave);a.addEventListener('blur',leave);
a.addEventListener('animationend',e=>{if(e.animationName==='hj-social-return')a.classList.remove('is-returning')});
});
}
document.querySelectorAll('[data-hj-footer]').forEach(initHJFooter);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hj-footer]').forEach(initHJFooter));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-contact"] && !Shopify.designMode) return;
  try {
    

function initHJContact(scope){
scope.querySelectorAll('.hj-contact-form').forEach(form=>{
if(form.dataset.ajaxReady)return;form.dataset.ajaxReady='true';
form.addEventListener('submit',async event=>{
if(event.defaultPrevented)return;
event.preventDefault();
if(form.dataset.sending==='true')return;
const button=form.querySelector('[type="submit"]'),feedback=form.querySelector('.hj-contact-feedback');
const body=new FormData(form);
form.dataset.sending='true';button.disabled=true;form.setAttribute('aria-busy','true');
try{
const url=new URL(form.action,location.href);url.hash='';
const response=await fetch(url,{method:'POST',body,credentials:'same-origin'});
const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html');
const returned=doc.querySelector('.hj-contact-form'),success=returned?.querySelector('.hj-contact-success'),errors=returned?.querySelector('[role="alert"]');
if(success){
feedback.replaceChildren(document.importNode(success,true));
form.reset();
}else if(errors){
feedback.replaceChildren(document.importNode(errors,true));
}else{
const message=document.createElement('p');message.setAttribute('role','alert');
message.textContent='We couldn’t confirm your message was sent. Please email hello@hardjelly.co.uk.';
if(new URL(response.url).pathname.includes('/challenge')){
message.textContent='Please complete Shopify’s security check to continue.';
const link=document.createElement('a');link.href=response.url;link.textContent=' Complete security check';message.append(link);
}
feedback.replaceChildren(message);
}
}catch(error){
const message=document.createElement('p');message.setAttribute('role','alert');message.textContent='We couldn’t confirm delivery. Please check your connection or email hello@hardjelly.co.uk.';feedback.replaceChildren(message);
}finally{delete form.dataset.sending;button.disabled=false;form.removeAttribute('aria-busy')}
});
});
}
initHJContact(document);
document.addEventListener('shopify:section:load',event=>initHJContact(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-delivery"]) return;
  try {
    
function initHJDelivery(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
const overview=root.querySelector('.hj-delivery-overview');
const rightColumn=root.querySelector('.hj-delivery-column:nth-child(2)');
if(overview&&rightColumn){
  const syncOverviewOffset=()=>{
    if(matchMedia('(min-width: 750px)').matches){
      const marginBottom=parseFloat(getComputedStyle(overview).marginBottom)||0;
      rightColumn.style.marginTop=(overview.offsetHeight+marginBottom)+'px';
    }else{
      rightColumn.style.marginTop='';
    }
  };
  syncOverviewOffset();
  window.addEventListener('resize',syncOverviewOffset,{passive:true});
  if('ResizeObserver' in window)new ResizeObserver(syncOverviewOffset).observe(overview);
}
root.querySelectorAll('.hj-delivery-columns details').forEach(detail=>{
    const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
    let animation=null,expanded=detail.open;
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=detail.getBoundingClientRect().height;
      expanded=!expanded;
      animation?.cancel();
      detail.open=true;
      detail.style.height='auto';
      const border= parseFloat(getComputedStyle(detail).borderTopWidth)+parseFloat(getComputedStyle(detail).borderBottomWidth);
      const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
      summary.setAttribute('aria-expanded',String(expanded));
      panel.inert=!expanded;
      const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
      if(reduced.matches){finish();return}
      animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});
      animation.onfinish=finish;
    });
  });
}
document.querySelectorAll('[data-hj-delivery]').forEach(initHJDelivery);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-delivery]').forEach(initHJDelivery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-faq"]) return;
  try {
    
function initHJFAQ(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
root.querySelectorAll('.hj-faq-columns details').forEach(detail=>{
    const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
    let animation=null,expanded=detail.open;
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=detail.getBoundingClientRect().height;
      expanded=!expanded;
      animation?.cancel();
      detail.open=true;
      detail.style.height='auto';
      const border= parseFloat(getComputedStyle(detail).borderTopWidth)+parseFloat(getComputedStyle(detail).borderBottomWidth);
      const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
      summary.setAttribute('aria-expanded',String(expanded));
      panel.inert=!expanded;
      const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
      if(reduced.matches){finish();return}
      animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});
      animation.onfinish=finish;
    });
  });
}
document.querySelectorAll('[data-hj-faq]').forEach(initHJFAQ);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-faq]').forEach(initHJFAQ));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-games"]) return;
  try {
    
function initHJGameNumbers(scope){
  scope.querySelectorAll('.hj-game-rules p').forEach(p=>{
    if(p.dataset.numberReady)return;
    const first=p.firstChild;
    if(!first||first.nodeType!==Node.TEXT_NODE)return;
    const match=first.textContent.match(/^\s*(\d+)\)\s*/);
    if(!match)return;
    first.textContent=first.textContent.slice(match[0].length);
    const badge=document.createElement('span');
    badge.className='hj-game-step-number';
    badge.textContent=match[1];
    badge.setAttribute('aria-hidden','true');
    p.prepend(badge);
    p.dataset.numberReady='true';
  });
}
initHJGameNumbers(document);
document.addEventListener('shopify:section:load',event=>initHJGameNumbers(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-nutrition"]) return;
  try {
    
function initHJNutrition(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
root.querySelectorAll('.hj-nutrition-columns details').forEach(detail=>{
    const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
    let animation=null,expanded=detail.open;
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=detail.getBoundingClientRect().height;
      expanded=!expanded;
      animation?.cancel();
      detail.open=true;
      detail.style.height='auto';
      const border= parseFloat(getComputedStyle(detail).borderTopWidth)+parseFloat(getComputedStyle(detail).borderBottomWidth);
      const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
      summary.setAttribute('aria-expanded',String(expanded));
      panel.inert=!expanded;
      const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
      if(reduced.matches){finish();return}
      animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});
      animation.onfinish=finish;
    });
  });
}
document.querySelectorAll('[data-hj-nutrition]').forEach(initHJNutrition);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-nutrition]').forEach(initHJNutrition));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-ready-made-hero"] && !Shopify.designMode) return;
  try {
    
(function(){
  const key='hj-birthday-gift-note-v1';
  function init(root){
    if(root.dataset.ready)return;root.dataset.ready='true';
    const to=root.querySelector('[data-gift-to]'),from=root.querySelector('[data-gift-from]'),message=root.querySelector('[data-gift-message]'),count=root.querySelector('[data-gift-count]');
    try{const saved=JSON.parse(sessionStorage.getItem(key)||'null');if(saved&&Date.now()-Number(saved.updated||0)<7200000){to.value=String(saved.to||'').slice(0,60);from.value=String(saved.from||'').slice(0,60);message.value=String(saved.message||'').slice(0,300)}}catch(error){}
    function save(){count.textContent=String(message.value.length);try{if(to.value.trim()||from.value.trim()||message.value.trim()){sessionStorage.setItem(key,JSON.stringify({to:to.value,from:from.value,message:message.value,updated:Date.now()}))}else{sessionStorage.removeItem(key)}}catch(error){}}
    root.addEventListener('input',save);
    save();
  }
  document.querySelectorAll('[data-hj-birthday-note]').forEach(init);
  document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-birthday-note]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-ready-made"] && !Shopify.designMode) return;
  try {
    
function initReadyFaq(scope){
  scope.querySelectorAll('.hj-ready__questions details').forEach(details=>{
    if(details.dataset.slideReady)return;
    details.dataset.slideReady='true';
    const summary=details.querySelector('summary');
    let animation=null,target=details.open;
    summary.setAttribute('aria-expanded',String(target));
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=details.getBoundingClientRect().height;
      target=!target;
      animation?.cancel();
      summary.setAttribute('aria-expanded',String(target));
      if(matchMedia('(prefers-reduced-motion: reduce)').matches){
        details.open=target;details.style.height='';return;
      }
      details.style.height='';
      details.open=true;
      const end=target?details.getBoundingClientRect().height:summary.getBoundingClientRect().height+parseFloat(getComputedStyle(details).borderTopWidth)+parseFloat(getComputedStyle(details).borderBottomWidth);
      animation=details.animate([{height:start+'px'},{height:end+'px'}],{duration:300,easing:'ease-in-out'});
      animation.onfinish=()=>{details.open=target;details.style.height='';animation=null;};
    });
  });
}
initReadyFaq(document);
document.addEventListener('shopify:section:load',event=>initReadyFaq(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-reviews-page"] && !Shopify.designMode) return;
  try {
    
function initHJReviewPage(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const allBoxes=[...root.querySelectorAll('.hj-review-box')];allBoxes.forEach((box,index)=>box.classList.add(index===1?'is-blue':'is-red'));const boxes=allBoxes.map((box,index)=>({box,slides:[...box.querySelectorAll('.hj-review-slide')],index:0,blue:index===1,paused:false})).filter(b=>b.slides.length>1);boxes.forEach(b=>{b.box.addEventListener('mouseenter',()=>{b.paused=true});b.box.addEventListener('mouseleave',()=>{b.paused=false})});
const reduced=matchMedia('(prefers-reduced-motion: reduce)');
let timer=setInterval(()=>{
if(!root.isConnected){clearInterval(timer);return}
if(document.hidden||reduced.matches)return;
boxes.forEach(b=>{if(b.paused)return;b.slides[b.index].classList.remove('is-active');b.slides[b.index].setAttribute('aria-hidden','true');b.index=(b.index+1)%b.slides.length;b.slides[b.index].classList.add('is-active');b.slides[b.index].removeAttribute('aria-hidden');b.blue=!b.blue;b.box.classList.toggle('is-blue',b.blue);b.box.classList.toggle('is-red',!b.blue)});
},4000);
root.addEventListener('hj-review-cleanup',()=>clearInterval(timer),{once:true});
}
document.querySelectorAll('[data-hj-review-page]').forEach(initHJReviewPage);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hj-review-page]').forEach(initHJReviewPage));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-hj-review-page]').forEach(r=>r.dispatchEvent(new Event('hj-review-cleanup'))));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-trade-contact"] && !Shopify.designMode) return;
  try {
    

function initHJTradeContact(scope){
scope.querySelectorAll('.hj-trade-contact-form').forEach(form=>{
if(form.dataset.ajaxReady)return;form.dataset.ajaxReady='true';
form.addEventListener('submit',async event=>{
if(event.defaultPrevented)return;
event.preventDefault();
if(form.dataset.sending==='true')return;
const button=form.querySelector('[type="submit"]'),feedback=form.querySelector('.hj-trade-contact-feedback');
const body=new FormData(form);
form.dataset.sending='true';button.disabled=true;form.setAttribute('aria-busy','true');
try{
const url=new URL(form.action,location.href);url.hash='';
const response=await fetch(url,{method:'POST',body,credentials:'same-origin'});
const html=await response.text(),doc=new DOMParser().parseFromString(html,'text/html');
const returned=doc.querySelector('.hj-trade-contact-form'),success=returned?.querySelector('.hj-trade-contact-success'),errors=returned?.querySelector('[role="alert"]');
if(success){
feedback.replaceChildren(document.importNode(success,true));
form.reset();
}else if(errors){
feedback.replaceChildren(document.importNode(errors,true));
}else{
const message=document.createElement('p');message.setAttribute('role','alert');
message.textContent='We couldn’t confirm your message was sent. Please email hello@hardjelly.co.uk.';
if(new URL(response.url).pathname.includes('/challenge')){
message.textContent='Please complete Shopify’s security check to continue.';
const link=document.createElement('a');link.href=response.url;link.textContent=' Complete security check';message.append(link);
}
feedback.replaceChildren(message);
}
}catch(error){
const message=document.createElement('p');message.setAttribute('role','alert');message.textContent='We couldn’t confirm delivery. Please check your connection or email hello@hardjelly.co.uk.';feedback.replaceChildren(message);
}finally{delete form.dataset.sending;button.disabled=false;form.removeAttribute('aria-busy')}
});
});
}
function initHJTradeSlides(scope){
  scope.querySelectorAll('[data-hj-trade-slideshow]').forEach(slideshow=>{
    if(slideshow.dataset.slideshowReady)return;
    slideshow.dataset.slideshowReady='true';
    // Use one continuous stack even though Shopify still has two editable groups of four.
    const photos=[...slideshow.querySelectorAll('.hj-trade-landing__slide')];
    if(!photos.length)return;
    const maxLayers=4;
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    const fetched=new WeakMap();
    let currentIndex=0,order=1,timer=null,retireTimer=null,fadeCleanupTimer=null,pendingRetire=null,stopped=false;
    let generation=0;
    const visible=[photos[0]];
    function loadPhoto(photo){
      if(fetched.has(photo))return fetched.get(photo);
      if(photo.dataset.srcset){
        photo.srcset=photo.dataset.srcset;
        photo.src=photo.dataset.src;
        delete photo.dataset.srcset;
        delete photo.dataset.src;
      }
      const promise=photo.decode?photo.decode().catch(()=>{}):Promise.resolve();
      fetched.set(photo,promise);
      return promise;
    }
    photos.forEach((photo,i)=>{
      photo.classList.toggle('is-stacked',i===0);
      photo.classList.toggle('is-active',i===0);
      photo.style.zIndex=i===0?'1':'0';
    });
    if(photos.length<2)return;
    // Only the next image is fetched ahead of its turn.
    loadPhoto(photos[1]);
    function finishRetirement(){
      if(retireTimer!==null){clearTimeout(retireTimer);retireTimer=null}
      if(fadeCleanupTimer!==null){clearTimeout(fadeCleanupTimer);fadeCleanupTimer=null}
      if(pendingRetire){
        const photo=pendingRetire;
        // Clear the hidden image without replaying its entrance transform.
        photo.classList.remove('is-stacked','is-active','is-retiring');
        photo.style.zIndex='0';
        pendingRetire=null;
      }
    }
    function fadeBottom(){
      retireTimer=null;
      if(!pendingRetire)return;
      // Only opacity changes. The bottom photo stays in place while fading.
      pendingRetire.classList.add('is-retiring');
      fadeCleanupTimer=setTimeout(finishRetirement,400);
    }
    function stop(){
      if(timer!==null){clearTimeout(timer);timer=null}
      finishRetirement();
    }
    function schedule(){
      if(stopped||document.hidden||reducedMotion.matches)return;
      if(timer!==null)clearTimeout(timer);
      timer=setTimeout(advance,1200);
    }
    async function advance(){
      timer=null;
      if(stopped||document.hidden||reducedMotion.matches)return;
      const token=++generation;
      const nextIndex=(currentIndex+1)%photos.length;
      const incoming=photos[nextIndex];
      await loadPhoto(incoming);
      if(stopped||document.hidden||reducedMotion.matches||token!==generation)return;
      currentIndex=nextIndex;
      // Place the next print over the existing pile; nothing disappears at the
      // four-photo boundary or when we loop back to the first Shopify image.
      incoming.style.zIndex=String(++order);
      incoming.classList.add('is-stacked','is-active');
      visible.push(incoming);
      if(visible.length>maxLayers){
        const oldest=visible.shift();
        // Wait for the drop to finish before quietly removing the hidden bottom photo.
        pendingRetire=oldest;
        retireTimer=setTimeout(fadeBottom,720);
      }
      loadPhoto(photos[(currentIndex+1)%photos.length]);
      schedule();
    }
    function onVisibility(){
      if(document.hidden){generation++;stop()}
      else schedule();
    }
    function onMotionChange(){
      generation++;
      stop();
      if(!reducedMotion.matches)schedule();
    }
    document.addEventListener('visibilitychange',onVisibility);
    reducedMotion.addEventListener('change',onMotionChange);
    const onUnload=event=>{
      if(!event.target.contains(slideshow))return;
      stopped=true;
      generation++;
      stop();
      document.removeEventListener('visibilitychange',onVisibility);
      reducedMotion.removeEventListener('change',onMotionChange);
      document.removeEventListener('shopify:section:unload',onUnload);
    };
    document.addEventListener('shopify:section:unload',onUnload);
    schedule();
  });
}
function initHJTradeReviewCarousel(scope){
  scope.querySelectorAll('[data-hj-trade-review-carousel]').forEach(carousel=>{
    if(carousel.dataset.reviewsReady)return;
    carousel.dataset.reviewsReady='true';
    const reviews=[...carousel.querySelectorAll('.hj-trade-landing__review')];
    if(reviews.length<2)return;
    const mobile=window.matchMedia('(max-width: 749px)');
    const reducedMotion=window.matchMedia('(prefers-reduced-motion: reduce)');
    let index=0,timer=null,fadeTimer=null,showTimer=null;
    function stop(){
      if(timer!==null){clearInterval(timer);timer=null}
      if(fadeTimer!==null){clearTimeout(fadeTimer);fadeTimer=null}
      if(showTimer!==null){clearTimeout(showTimer);showTimer=null}
    }
    function show(next){
      reviews[index].classList.remove('is-current-review');
      index=next;
      reviews[index].classList.add('is-current-review');
    }
    function advance(){
      if(reducedMotion.matches){show((index+1)%reviews.length);return}
      carousel.classList.add('is-fading-review');
      fadeTimer=setTimeout(()=>{
        fadeTimer=null;
        show((index+1)%reviews.length);
        // Let the card's background briefly show through as white between reviews.
        showTimer=setTimeout(()=>{
          showTimer=null;
          carousel.classList.remove('is-fading-review');
        },180);
      },400);
    }
    function start(){
      stop();
      carousel.classList.remove('is-fading-review');
      if(!mobile.matches||reducedMotion.matches||document.hidden)return;
      timer=setInterval(advance,5000);
    }
    const refresh=()=>{stop();carousel.classList.remove('is-fading-review');if(!mobile.matches)show(0);start()};
    mobile.addEventListener('change',refresh);
    reducedMotion.addEventListener('change',refresh);
    document.addEventListener('visibilitychange',refresh);
    const onUnload=event=>{
      if(!event.target.contains(carousel))return;
      stop();
      mobile.removeEventListener('change',refresh);
      reducedMotion.removeEventListener('change',refresh);
      document.removeEventListener('visibilitychange',refresh);
      document.removeEventListener('shopify:section:unload',onUnload);
    };
    document.addEventListener('shopify:section:unload',onUnload);
    start();
  });
}
initHJTradeReviewCarousel(document);
initHJTradeSlides(document);
initHJTradeContact(document);
document.addEventListener('shopify:section:load',event=>initHJTradeContact(event.target));
document.addEventListener('shopify:section:load',event=>initHJTradeSlides(event.target));
document.addEventListener('shopify:section:load',event=>initHJTradeReviewCarousel(event.target));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-trade-store"] && !Shopify.designMode) return;
  try {
    
function initHJTrade(root){
 if(root.dataset.ready)return;root.dataset.ready='true';
 const copy=JSON.parse(root.querySelector('[data-trade-copy]').textContent),gate=root.querySelector('[data-trade-gate]'),shop=root.querySelector('[data-trade-shop]'),message=root.querySelector('[data-trade-message]'),grid=root.querySelector('[data-trade-products]'),order=root.querySelector('[data-trade-order]'),checkout=root.querySelector('[data-trade-checkout]'),totalEx=root.querySelector('[data-trade-total]'),totalInc=root.querySelector('[data-trade-total-inc]'),mobileCart=root.querySelector('[data-trade-mobile-cart]'),mobileTotal=root.querySelector('[data-trade-mobile-total]'),mobileTotalInc=root.querySelector('[data-trade-mobile-total-inc]'),mobileCheckout=root.querySelector('[data-trade-mobile-checkout]'),toast=root.querySelector('[data-trade-toast]');

 function alignTradeCards(){
  const selectors=['.hj-trade-title','.hj-trade-pack-info','.hj-trade-card__price','.hj-trade-price-inclusive'];
  const cards=[...grid.querySelectorAll('.hj-trade-card--shots')];
  cards.forEach(card=>selectors.forEach(selector=>{const item=card.querySelector(selector);if(item)item.style.minHeight=''}));
  if(matchMedia('(max-width:749px)').matches||!grid.getBoundingClientRect().width)return;
  const rows=new Map();
  cards.forEach(card=>{const top=Math.round(card.offsetTop);if(!rows.has(top))rows.set(top,[]);rows.get(top).push(card)});
  rows.forEach(row=>{
   if(row.length<2)return;
   selectors.forEach(selector=>{
    const items=row.map(card=>card.querySelector(selector)).filter(Boolean);
    const height=Math.ceil(Math.max(0,...items.map(item=>item.getBoundingClientRect().height)));
    items.forEach(item=>item.style.minHeight=height+'px');
   });
  });
 }
 let cardAlignFrame=0,cardGridWidth=-1;
 function scheduleCardAlignment(){cancelAnimationFrame(cardAlignFrame);cardAlignFrame=requestAnimationFrame(()=>{if(root.isConnected)alignTradeCards()})}
 const cardResize=new ResizeObserver(entries=>{
  const width=entries[0].contentRect.width;
  if(width!==cardGridWidth){cardGridWidth=width;scheduleCardAlignment()}
 });
 cardResize.observe(grid);
 document.fonts.ready.then(scheduleCardAlignment);
 document.addEventListener('shopify:section:unload',event=>{
  if(event.target.contains(root)){cardResize.disconnect();cancelAnimationFrame(cardAlignFrame)}
 });
 root.querySelectorAll('.hj-trade-info-sliders details').forEach(detail=>{
  const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
  let animation=null,expanded=detail.open;
  summary.addEventListener('click',event=>{
   event.preventDefault();const start=detail.getBoundingClientRect().height;expanded=!expanded;animation?.cancel();detail.open=true;detail.style.height='auto';
   const style=getComputedStyle(detail),border=parseFloat(style.borderTopWidth)+parseFloat(style.borderBottomWidth);
   const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
   summary.setAttribute('aria-expanded',String(expanded));panel.inert=!expanded;
   const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
   if(matchMedia('(prefers-reduced-motion:reduce)').matches){finish();return}
   animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});animation.onfinish=finish;
  });
 });
 const endpoint=root.dataset.endpoint.replace(/\/$/,'');
 const tabStrip=root.querySelector('[data-trade-tabs]');
 function positionTabIndicator(){const active=tabStrip.querySelector('button[aria-pressed="true"]'),indicator=tabStrip.querySelector('.hj-trade-tab-indicator');if(!active||!indicator)return;indicator.style.width=active.offsetWidth+'px';indicator.style.transform='translateX('+active.offsetLeft+'px)'}
 const tabResize=new ResizeObserver(positionTabIndicator);tabResize.observe(tabStrip);
 document.fonts.ready.then(()=>{if(root.isConnected)positionTabIndicator()});
 document.addEventListener('shopify:section:unload',event=>{if(event.target.contains(root))tabResize.disconnect()},{once:true});
 let token='',products=[],collections=[],quantities=new Map(),group='',requestId='',busy=false;
 let pricingEnabled=false,priceMap=new Map(),priceRefresh=new Set(),quote=null,quoteRequested='',quotePending=false,quoteError=false,quoteTimer=0,quoteSerial=0;
 const pricingStatus=root.querySelector('[data-trade-pricing-status]');
 const cartKey=()=>JSON.stringify([...quantities].sort(([a],[b])=>a.localeCompare(b)));
 const currentQuote=()=>quote&&quote.key===cartKey()?quote:null;
 function displayedPrice(v){
  const line=currentQuote()?.lines.find(line=>line.id===v.id);
  return line?line.total/line.quantity/100:(priceMap.get(v.id)?.price??Math.round(Number(v.price)*100))/100;
 }
 function updateCardPrices(){if(busy)return;priceRefresh.forEach(refresh=>refresh());scheduleCardAlignment()}
 function resetPricing(){clearTimeout(quoteTimer);quoteSerial++;quote=null;quoteRequested='';quotePending=false;quoteError=false;priceMap.clear();pricingEnabled=false;if(pricingStatus)pricingStatus.hidden=true;}
 function scheduleQuote(){
  if(!pricingEnabled)return;
  const key=cartKey();
  if(!quantities.size||needsPaid()){clearTimeout(quoteTimer);quoteSerial++;quote=null;quoteRequested='';quotePending=false;quoteError=false;return}
  if(key===quoteRequested)return;
  clearTimeout(quoteTimer);quoteRequested=key;quote=null;quotePending=true;quoteError=false;
  const serial=++quoteSerial,sessionToken=token,items=[...quantities].map(([id,quantity])=>({id,quantity}));
  quoteTimer=setTimeout(async()=>{
   try{
    const result=await api('/quote',{items});
    if(serial!==quoteSerial||sessionToken!==token||key!==cartKey())return;
    if(!Number.isFinite(result.gross)||!Number.isFinite(result.net)||!Array.isArray(result.lines))throw Error('Invalid price');
    quote={...result,key};quotePending=false;quoteError=false;
   }catch(error){
    if(serial!==quoteSerial||sessionToken!==token)return;
    quotePending=false;quoteError=true;
   }
   summary();updateCardPrices();
  },300);
 }
 async function loadAccountPrices(){
  if(!pricingEnabled)return;
  const sessionToken=token;
  pricingStatus.hidden=true;pricingStatus.textContent='';
  const items=products.flatMap(p=>p.variants.filter(v=>v.available&&Number(v.price)>0).map(v=>({id:v.id,quantity:1})));
  try{
   const rows=[];
   for(let offset=0;offset<items.length;offset+=12){
    const result=await api('/prices',{items:items.slice(offset,offset+12)});
    if(sessionToken!==token)return;
    if(!Array.isArray(result.prices))throw Error('Invalid prices');
    rows.push(...result.prices);
   }
   priceMap=new Map(rows.map(row=>[row.id,row]));pricingStatus.hidden=true;
  }catch(error){
   if(sessionToken!==token)return;
   pricingStatus.hidden=false;pricingStatus.textContent=copy.price_error;
   const retry=el('button',copy.price_retry);retry.type='button';retry.onclick=()=>loadAccountPrices();pricingStatus.append(' ',retry);
  }
  updateCardPrices();summary();
 }
 const configuredIds=[...root.querySelectorAll('[data-collection-id]')].map(n=>n.dataset.collectionId.trim().replace('gid://shopify/Collection/','')).filter(Boolean);
 const collectionOrder=[...new Set(configuredIds)].map(id=>'gid://shopify/Collection/'+id);
 const collectionTitles=new Map([...root.querySelectorAll('[data-collection-id]')].map(n=>['gid://shopify/Collection/'+n.dataset.collectionId.trim().replace('gid://shopify/Collection/',''),n.dataset.collectionTitle.trim()]));
 const money=value=>new Intl.NumberFormat('en-GB',{style:'currency',currency:'GBP'}).format(value);
 const el=(tag,text,cls)=>{const n=document.createElement(tag);if(text!==undefined)n.textContent=text;if(cls)n.className=cls;return n};
 async function requestTrade(base,path,data={}){
  const controller=new AbortController(),timeout=setTimeout(()=>controller.abort(),path==='/prices'?45000:20000);
  try{
   const response=await fetch(base+path,{method:'POST',headers:{'Content-Type':'application/json',...(token?{Authorization:'Bearer '+token}:{})},body:JSON.stringify(data),cache:'no-store',signal:controller.signal});
   let result={};try{result=await response.json()}catch{}
   if(!response.ok){
    if(response.status===401)lock();
    const error=Error(result.error||copy.unavailable);error.isHttp=true;throw error;
   }
   return result;
  }finally{clearTimeout(timeout)}
 }
 async function api(path,data={}){
  if(!endpoint||!endpoint.startsWith('https://'))throw Error(copy.unavailable);
  try{
   return await requestTrade(endpoint,path,data);
  }catch(error){
   if(error.isHttp)throw error;
   console.warn('Trade API connection failed',error);
   throw Error(copy.network_error||'We couldn’t connect to the trade store. Please try refreshing, another browser or network, or contact us.');
  }
 }
 function lock(){resetPricing();token='';try{sessionStorage.removeItem('hj-trade-session')}catch{}products=[];quantities.clear();grid.replaceChildren();order.replaceChildren();shop.hidden=true;gate.hidden=false;if(mobileCart)mobileCart.hidden=true;totalEx.textContent='';if(totalInc)totalInc.textContent='';if(mobileTotal)mobileTotal.textContent='';if(mobileTotalInc)mobileTotalInc.textContent='';}
 function rules(p){
  const match=/\bmax(?:imum)?\s+(\d+|one|two)(?:\s+packs?)?\s+per\s+order\b/i.exec(p.title);
  const max=Object.prototype.hasOwnProperty.call(p,'maxPerOrder')?p.maxPerOrder:(match?({one:1,two:2}[match[1].toLowerCase()]||Number(match[1])):null);
  return {max:max??999,limited:max!=null,pos:p.requiresPaidProduct??(p.collectionIds||[]).includes('gid://shopify/Collection/686266417527')};
 }
 function needsPaid(){return products.some(p=>rules(p).pos&&p.variants.some(v=>quantities.get(v.id)>0))&&!products.some(p=>p.variants.some(v=>quantities.get(v.id)>0&&Number(v.price)>0))}
 let toastTimer;
 function flashAdded(){
  if(!toast)return;
  clearTimeout(toastTimer);
  toast.hidden=false;
  requestAnimationFrame(()=>toast.classList.add('is-visible'));
  toastTimer=setTimeout(()=>{toast.classList.remove('is-visible');setTimeout(()=>{toast.hidden=true},190)},1100);
 }
 function summary(){
  scheduleQuote();
  const calculated=currentQuote();
  order.replaceChildren();let total=0,originalTotal=0;
  for(const p of products)for(const v of p.variants){const qty=quantities.get(v.id)||0;if(!qty)continue;const line=calculated?.lines.find(line=>line.id===v.id);const lineTotal=line?line.total:Math.round(displayedPrice(v)*100)*qty;total+=lineTotal;originalTotal+=Math.round(Number(v.price)*100)*qty;
   const row=el('div',p.title.replace(/\s*\(trade\)/gi,'').replace(/\s*[—–-]\s*75\s*total\s*shots\s*per\s*box/i,' x 75 shots')+(v.title==='Default Title'?'':' — '+v.title)+' × '+qty+' · '+money(lineTotal/100),'hj-trade-order-row');
   const remove=el('button',copy.remove);remove.type='button';remove.onclick=()=>{quantities.delete(v.id);requestId='';render()};row.append(el('br'),remove);order.append(row);
  }
  if(!quantities.size)order.append(el('p',copy.order_empty));
  const grossTotal=calculated?calculated.gross/100:total/100,netTotal=calculated?calculated.net/100:grossTotal/1.2;
  if(calculated&&originalTotal>calculated.gross)order.append(el('p',copy.your_discount+' · '+money((originalTotal-calculated.gross)/100)+' '+copy.price_saved,'hj-trade-account-saving'));
  if(quoteError){const retry=el('button',copy.price_retry);retry.type='button';retry.onclick=()=>{quoteRequested='';summary()};const note=el('p',copy.price_error);note.append(' ',retry);order.append(note)}
  totalEx.textContent=money(netTotal);
  if(totalInc)totalInc.textContent=money(grossTotal)+' '+copy.inc_vat;
  root.querySelector('[data-trade-requirement]').hidden=!needsPaid();
  checkout.disabled=!quantities.size||busy||needsPaid()||quotePending;
  if(mobileTotal)mobileTotal.textContent=money(netTotal);
  if(mobileTotalInc)mobileTotalInc.textContent=money(grossTotal)+' '+copy.inc_vat;
  if(mobileCart)mobileCart.hidden=!quantities.size;
  if(mobileCheckout)mobileCheckout.disabled=!quantities.size||busy||needsPaid()||quotePending;
 }
 function render(){
  priceRefresh.clear();grid.replaceChildren();
  const selected=collections.find(c=>c.id===group);
  const visible=selected?selected.productIds.map(id=>products.find(p=>p.id===id)).filter(Boolean):products.filter(p=>!group||p.group===group);
  root.querySelector('[data-trade-pos-note]').hidden=group!=='gid://shopify/Collection/686266417527'&&!visible.some(p=>rules(p).pos);
  for(const p of visible){
   const card=el('article',undefined,'hj-trade-card');
   const media=el('div',undefined,'hj-trade-media');
   if(p.image){const img=el('img');img.src=p.image;img.alt=p.title;img.loading='lazy';img.className='hj-trade-image-primary';media.append(img);if(p.image2){const img2=el('img');img2.src=p.image2;img2.alt=p.title;img2.loading='lazy';img2.className='hj-trade-image-secondary';media.append(img2)}card.append(media)}
   const rule=rules(p);
   const saleProduct=root.dataset.tradeSale==='true'&&['on-trade-flavour-pack-2','on-trade-watermelon-75','on-trade-lemonlime-75','on-trade-orange-75'].includes(p.handle);
   let saleBadge=null;
   if(saleProduct){
     saleBadge=el('span','15% OFF','hj-trade-badge hj-trade-badge--sale');
     saleBadge.hidden=true;
     (p.image?media:card).append(saleBadge);
   }
   const mixed=(p.collectionIds||[]).includes('gid://shopify/Collection/698663207287')||group==='gid://shopify/Collection/698663207287'||/flavour-pack-[123]$/.test(p.handle||'');
   const shotPack=!rule.pos&&(mixed||group==='gid://shopify/Collection/698814071159'||/75\s*shots/i.test(p.title)||/-75$/.test(p.handle||''));
   const palette=[['strawberry','#fff1f2'],['sour apple','#f3f9ec'],['black cherry','#faf0f3'],['watermelon','#fff2f3'],['lemon','#fbfbea'],['orange','#fff5eb'],['blue raspberry','#eef7ff'],['pineapple','#fffbea'],['black grape','#f5effa']];
   const name=p.title.toLowerCase(),matches=palette.filter(([flavour])=>name.includes(flavour)).sort((a,b)=>name.indexOf(a[0])-name.indexOf(b[0]));
   const tint=(rule.pos||group==='gid://shopify/Collection/686266417527'||p.id==='gid://shopify/Product/14873875644791')?'#f4f4f4':/flavour-pack-2$/.test(p.handle||'')?'#fbfbea':matches[0]?.[1]||'#fff3f6';
   const body=el('div',undefined,'hj-trade-card__body');body.style.background=tint;card.append(body);
   if(shotPack)card.classList.add('hj-trade-card--shots');
   if(group==='gid://shopify/Collection/698663207287')(p.image?media:card).append(el('span',copy.mixed_badge,'hj-trade-badge hj-trade-badge--mixed'));
   if(rule.limited)(p.image?media:card).append(el('span',copy.max_many.replace('[count]',rule.max),'hj-trade-badge'));
   const titleParts=p.title.split('|').map(part=>part.trim()).filter(Boolean);
   if(group==='gid://shopify/Collection/698814071159'){
    const flavour=p.title.replace(/\s*(?:x|[—–-])\s*75\s*(?:total\s*)?shots(?:\s*total)?(?:\s*per\s*box)?(?:\s*\(trade\))?\s*$/i,'').trim();
    const title=el('h2',undefined,'hj-trade-title hj-trade-title--split');
    title.append(
      el('span',p.tradePackLabel||'Single flavour pack','hj-trade-title__pack'),
      el('span',flavour,'hj-trade-title__flavours')
    );
    body.append(title);
   }else if(group==='gid://shopify/Collection/698663207287'){
    const flavour=p.title.replace(/\s*(?:x|[—–-])\s*75\s*(?:total\s*)?shots(?:\s*total)?(?:\s*per\s*box)?(?:\s*\(trade\))?\s*$/i,'').trim();
    let pack=p.tradePackLabel||'Flavour Pack';
    if(!p.tradePackLabel){
      if(/pack-1$/.test(p.handle))pack='Flavour Pack 1';
      else if(/pack-2$/.test(p.handle))pack='Flavour Pack 2';
      else if(/pack-3$/.test(p.handle))pack='Flavour Pack 3';
    }
    const title=el('h2',undefined,'hj-trade-title hj-trade-title--split');
    title.append(
      el('span',pack,'hj-trade-title__pack'),
      el('span',flavour,'hj-trade-title__flavours')
    );
    body.append(title);
   }else if(titleParts.length>=3){
    const title=el('h2',undefined,'hj-trade-title hj-trade-title--split');
    title.append(
      el('span',titleParts[0],'hj-trade-title__pack'),
      el('span',titleParts[1],'hj-trade-title__flavours'),
      el('span',titleParts.slice(2).join(' | '),'hj-trade-title__main')
    );
    body.append(title);
   }else{
    body.append(el('h2',p.title,'hj-trade-title'));
   }
   if(p.id==='gid://shopify/Product/14873875644791'){
    const download=el('a',copy.download,'hj-trade-button hj-trade-download');
    download.href=root.dataset.downloadUrl;download.target='_blank';download.rel='noopener';
    body.append(el('p',copy.download_note),download);grid.append(card);continue;
   }
   if(shotPack){
    const packInfo=el('div',undefined,'hj-trade-pack-info'),details=el('div');
    details.append(el('strong','total shots per box'));
    if(mixed)details.append(el('small','25 of each flavour'));
    packInfo.append(el('strong','75','hj-trade-pack-info__count'),details);body.append(packInfo);
   }
   const price=el('strong',undefined,'hj-trade-card__price'),select=el('select');select.setAttribute('aria-label',copy.variant+' '+p.title);
   p.variants.forEach(v=>{const option=el('option',v.title);option.value=v.id;select.append(option)});
   if(p.variants.length>1)body.append(select);
   const inclusivePrice=el('small',undefined,'hj-trade-price-inclusive');
   body.append(price,inclusivePrice);
   const controls=el('div',undefined,'hj-trade-controls'),minus=el('button','−'),plus=el('button','+'),input=el('input');
   input.type='number';input.min=0;input.max=999;input.step=1;input.setAttribute('aria-label',copy.quantity+' '+p.title);minus.type=plus.type='button';minus.setAttribute('aria-label','− '+p.title);plus.setAttribute('aria-label','+ '+p.title);
   const quantityTotal=el('div',undefined,'hj-trade-card__quantity-total');
   quantityTotal.setAttribute('aria-live','polite');
   if(shotPack){body.append(el('div','Number of boxes','hj-trade-card__quantity-label'));input.setAttribute('aria-label','Number of boxes for '+p.title)}
   const variant=()=>p.variants.find(v=>v.id===select.value);
   const remaining=()=>Math.max(0,rule.max-p.variants.reduce((n,v)=>n+(v.id===select.value?0:(quantities.get(v.id)||0)),0));
   function refresh(){const v=variant();const gross=displayedPrice(v),original=Number(v.price);if(saleBadge)saleBadge.hidden=!(gross<original-0.005);price.replaceChildren();if(gross<original-0.005)price.append(el('del',money(original/1.2)));price.append(el('span',money(gross/1.2)),el('small',' '+copy.plus_vat+(shotPack?' / box':'')));inclusivePrice.textContent=money(gross)+' '+copy.inc_vat+(v.available?'':' · '+copy.sold_out);if(gross<original-0.005)inclusivePrice.append(el('span',' · '+copy.your_discount,'hj-trade-account-saving'));input.value=quantities.get(v.id)||0;if(shotPack){const boxes=Number(input.value);quantityTotal.textContent=boxes?boxes+' '+(boxes===1?'box':'boxes')+' · '+(boxes*75)+' shots':''}input.max=remaining();plus.disabled=!v.available||Number(input.value)>=remaining();input.disabled=!v.available;minus.disabled=Number(input.value)<=0}
   function change(qty){const before=quantities.get(variant().id)||0;qty=Math.max(0,Math.min(remaining(),Math.trunc(qty)||0));const v=variant();if(!v.available)return;if(qty)quantities.set(v.id,qty);else quantities.delete(v.id);requestId='';summary();updateCardPrices();if(qty>before)flashAdded()}
   minus.onclick=()=>change(Number(input.value)-1);plus.onclick=()=>change(Number(input.value)+1);input.onchange=()=>change(Number(input.value));select.onchange=()=>{refresh();scheduleCardAlignment()};
   priceRefresh.add(refresh);controls.append(minus,input,plus);body.append(controls);if(shotPack)body.append(quantityTotal);refresh();grid.append(card);
  }
  if(!visible.length)grid.append(el('p',copy.empty));
  scheduleCardAlignment();
  summary();
 }
 async function load(){
  message.textContent=copy.loading;
  const data=await api('/catalog');resetPricing();products=data.products;pricingEnabled=data.pricingVersion===1;
  collections=Array.isArray(data.collections)?collectionOrder.map(id=>data.collections.find(c=>c.id===id)).filter(Boolean):[];
  if(Array.isArray(data.collections)){
   const included=new Set(collections.flatMap(c=>c.productIds));products=products.filter(p=>included.has(p.id));
   group=collections.some(c=>c.id===group)?group:(collections[0]?.id||'');
  }
  const validVariants=new Set(products.flatMap(p=>p.variants.map(v=>v.id)));
  for(const id of quantities.keys())if(!validVariants.has(id))quantities.delete(id);
  gate.hidden=true;shop.hidden=false;;message.textContent='';
  const tabs=root.querySelector('[data-trade-tabs]');tabs.replaceChildren();const indicator=el('span',undefined,'hj-trade-tab-indicator');indicator.setAttribute('aria-hidden','true');tabs.append(indicator);
  const options=Array.isArray(data.collections)?collections.map(c=>({id:c.id,title:collectionTitles.get(c.id)||c.title})):[...new Set(products.map(p=>p.group))].map(name=>({id:name,title:name}));
  if(!group&&options.length)group=options[0].id;
  for(const option of options){const b=el('button',option.title);b.type='button';b.setAttribute('aria-pressed',String(option.id===group));b.onclick=()=>{group=option.id;tabs.querySelectorAll('button').forEach(n=>n.setAttribute('aria-pressed',String(n===b)));positionTabIndicator();render()};tabs.append(b)}
  requestAnimationFrame(positionTabIndicator);
  render();
  if(pricingEnabled)loadAccountPrices();
 }
 root.querySelector('[data-trade-login]').onsubmit=async event=>{
  event.preventDefault();if(busy)return;busy=true;const button=event.target.querySelector('button');button.disabled=true;message.textContent=copy.loading;
  try{const data=await api('/login',{email:new FormData(event.target).get('email')});token=data.token;try{sessionStorage.setItem('hj-trade-session',token)}catch{}await load()}catch(error){message.textContent=error.message}finally{busy=false;button.disabled=false;summary()}
 };
 if(mobileCheckout)mobileCheckout.onclick=()=>checkout.click();
 checkout.onclick=async()=>{
  if(busy||!quantities.size||needsPaid())return;busy=true;root.querySelectorAll('button,input,select').forEach(n=>n.disabled=true);message.textContent=copy.loading;
  try{requestId=requestId||crypto.randomUUID();const data=await api('/checkout',{requestId,items:[...quantities].map(([id,quantity])=>({id,quantity}))});const url=new URL(data.checkoutUrl);if(url.protocol!=='https:'||!(url.hostname==='hardjelly.co.uk'||url.hostname==='hardjelly-9114.myshopify.com'||url.hostname==='checkout.shopify.com'))throw Error(copy.unavailable);location.assign(url.href)}
  catch(error){message.textContent=error.message}
  finally{busy=false;root.querySelectorAll('button,input,select').forEach(n=>n.disabled=false);render()}
 };
 try{token=sessionStorage.getItem('hj-trade-session')||''}catch{}
 if(token)load().catch(error=>{lock();message.textContent=error.message});
}
document.querySelectorAll('[data-trade-store]').forEach(initHJTrade);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-trade-store]').forEach(initHJTrade));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hj-visual-tray-test"]) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const strings = JSON.parse(root.querySelector('[data-strings]').textContent);
    const journey = JSON.parse(root.querySelector('[data-journey-strings]').textContent);
    const trayMetricsId='G-JM4X5WFTWL';
    const trayMetricsLayer='hjTrayAnalyticsData';
    let trayMetricsReady=false;
    function trayMetricsCommand(){
      window[trayMetricsLayer]=window[trayMetricsLayer]||[];
      window[trayMetricsLayer].push(arguments);
    }
    function trayAnalyticsAllowed(){
      try{return window.Shopify?.customerPrivacy?.analyticsProcessingAllowed()===true;}catch(error){return false;}
    }
    function trackTrayImage(eventName){
      try{
        if(window.Shopify?.designMode||!trayAnalyticsAllowed())return;
        if(!trayMetricsReady){
          trayMetricsReady=true;
          trayMetricsCommand('consent','default',{analytics_storage:'granted',ad_storage:'denied',ad_user_data:'denied',ad_personalization:'denied'});
          trayMetricsCommand('js',new Date());
          trayMetricsCommand('config',trayMetricsId,{send_page_view:false,allow_google_signals:false,allow_ad_personalization_signals:false,page_location:location.origin+location.pathname});
          if(!document.querySelector('script[data-hj-tray-analytics]')){
            const script=document.createElement('script');script.async=true;script.dataset.hjTrayAnalytics='true';
            script.src='https://www.googletagmanager.com/gtag/js?id='+trayMetricsId+'&l='+trayMetricsLayer;
            document.head.append(script);
          }
        }
        const headline=shareChoices.querySelector('input:checked')?.value;
        trayMetricsCommand('event',eventName,{send_to:trayMetricsId,content_type:'custom_tray_image',item_id:'custom-tray',pack_shots:Number(currentVariant()?.dataset.shots)||15,message_option:headline==='custom'?'custom':'preset_'+headline,page_location:location.origin+location.pathname});
      }catch(error){}
    }
    if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures){
      window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.2'}],()=>{});
    }
    document.addEventListener('visitorConsentCollected',()=>{
      if(trayMetricsReady)trayMetricsCommand('consent','update',{analytics_storage:trayAnalyticsAllowed()?'granted':'denied'});
    });

    const flavours = JSON.parse(root.querySelector('[data-flavours]').textContent);
    const byId = Object.fromEntries(flavours.map(f => [f.id, f]));
    const holder = root.querySelector('[data-slots]');
    const stage = root.querySelector('[data-stage]');
    const picker = root.querySelector('[data-picker]');
    const galleryImage = root.querySelector('[data-gallery-image]');
    const photoButtons = [...root.querySelectorAll('[data-tray-photo]')];
    const photoDots = [...root.querySelectorAll('[data-tray-dot]')];
    const backToBuilder = root.querySelector('[data-back-builder]');
    let galleryVersion=0,galleryFade;
    function showBuilder() {
      galleryVersion++;galleryFade?.cancel();
      stage.classList.remove('is-photo'); galleryImage.hidden = true;
      if(backToBuilder) backToBuilder.hidden = true;
      [...photoButtons,...photoDots].forEach(button=>button.setAttribute('aria-pressed','false'));
    }
    async function showPhoto(index) {
      const button = photoButtons[index]; if(!button)return;
      const version=++galleryVersion;
      const nextImage=new Image();nextImage.src=button.dataset.image;
      try { await nextImage.decode(); } catch(error) { return; }
      if(version!==galleryVersion)return;
      galleryFade?.cancel();
      const motion=!matchMedia('(prefers-reduced-motion: reduce)').matches;
      if(motion&&!galleryImage.hidden){
        galleryFade=galleryImage.animate([{opacity:1},{opacity:0}],{duration:140,easing:'ease-in',fill:'forwards'});
        try {await galleryFade.finished;}catch(error){return;}
      }
      if(version!==galleryVersion)return;
      galleryFade?.cancel();
      galleryImage.src=button.dataset.image;galleryImage.alt=button.dataset.alt;
      galleryImage.hidden=false;stage.classList.add('is-photo');backToBuilder.hidden=false;
      if(motion)galleryFade=galleryImage.animate([{opacity:0},{opacity:1}],{duration:240,easing:'ease-out'});
      photoButtons.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===index)));
      photoDots.forEach((item,i)=>item.setAttribute('aria-pressed',String(i===index)));
      button.scrollIntoView({block:'nearest',inline:'nearest',behavior:'instant'});
    }
    photoButtons.forEach((button,index)=>button.addEventListener('click',()=>showPhoto(index)));
    photoDots.forEach((button,index)=>button.addEventListener('click',()=>showPhoto(index)));
    backToBuilder?.addEventListener('click',()=>{showBuilder();picker.querySelector('button')?.focus({preventScroll:true});});
    picker.addEventListener('click',showBuilder,true);
    picker.addEventListener('pointerdown',showBuilder,true);

    let completionScrollTimer, completionHandled = false;
    const mobileLayout = matchMedia('(max-width:749px)');
    const download = root.querySelector('[data-download]');
    const downloadStatus = root.querySelector('[data-download-status]');
    let exporting = false;
    const count = root.querySelector('[data-count]');
    const status = root.querySelector('[data-status]');
    const progress = root.querySelector('[data-progress]');
    const form = root.querySelector('.hj-vtray__form');
    const buy = root.querySelector('[data-buy]');
    const purchaseStrings = JSON.parse(root.querySelector('[data-purchase-strings]').textContent);
    const selection = root.querySelector('[data-selection]');
    const error = root.querySelector('[data-buy-error]');
    const success = root.querySelector('[data-buy-success]');
    let busy = false;
    const rows = [[299,208,114,475,740,1005],[455.5,219,125,461.5,740,1017.5],[627.5,230,139,447,739,1031],[819,243,154,430.5,739,1046.5],[1032,257,172,412.5,738,1063]];
    let state = Array(15).fill(null);
    let selected = 'sour-apple';
    const draftKey = 'hj-visual-tray-v1';
    const giftKey = 'hj-visual-gift-v1';
    const giftToggle = document.getElementById(root.querySelector('[data-hj-gift]').dataset.toggleId);
    let loadingDraft = true;
    const history = [];
    let dragSource = null;
    let justDragged = false;
    let dragTimer;
    let landTimer;
    let impact;
    let pointerSession = null;
    let ghost = null;
    const buttons = [];
    const cards = [];
    const reduced = matchMedia('(prefers-reduced-motion: reduce)');
    function save() { history.push(state.slice()); if (history.length > 100) history.shift(); }
    function label(template, n, flavour) { return template.replace('[number]', n).replace('[flavour]', flavour || ''); }
    function finishDrag() {
      dragSource = null; justDragged = true;
      if (ghost) { ghost.remove(); ghost = null; }
      buttons.forEach(b => b.classList.remove('is-over','is-dragging'));
      clearTimeout(dragTimer);
      dragTimer = setTimeout(() => { justDragged = false; }, 150);
    }
    function makeDraggable(node, getSource) {
      node.addEventListener('pointerdown', e => {
        if (busy || e.pointerType !== 'mouse' || e.button !== 0 || !e.isPrimary || node.disabled) return;
        const source = getSource(); if (!source) return;
        pointerSession = {id:e.pointerId, x:e.clientX, y:e.clientY, source, node, active:false};
      });
    }
    root.addEventListener('dragstart', e => e.preventDefault());
    document.addEventListener('pointermove', e => {
      const p = pointerSession;
      if (!p || e.pointerId !== p.id) return;
      if (!p.active && Math.hypot(e.clientX-p.x,e.clientY-p.y) < 7) return;
      if (!p.active) {
        p.active = true; dragSource = p.source; selected = p.source.flavour;
        root.setPointerCapture(e.pointerId);
        p.node.classList.add('is-dragging');
        ghost = new Image(); ghost.src = byId[p.source.flavour].url; ghost.alt = '';
        ghost.className = 'hj-vtray__drag-ghost';
        document.body.append(ghost);
      }
      e.preventDefault();
      ghost.style.left = e.clientX + 'px'; ghost.style.top = e.clientY + 'px';
      const target = nearestSpace(e.clientX,e.clientY);
      buttons.forEach((b,i) => b.classList.toggle('is-over',i === target));
    }, {passive:false});
    document.addEventListener('pointerup', e => {
      const p = pointerSession;
      if (!p || e.pointerId !== p.id) return;
      pointerSession = null;
      if (!p.active) return;
      e.preventDefault();
      if (root.hasPointerCapture(e.pointerId)) root.releasePointerCapture(e.pointerId);
      p.node.classList.remove('is-dragging');
      const target = nearestSpace(e.clientX,e.clientY);
      commitDrop(target, p.source, !stage.contains(document.elementFromPoint(e.clientX,e.clientY)));
      finishDrag();
    });
    document.addEventListener('pointercancel', e => {
      if (!pointerSession || e.pointerId !== pointerSession.id) return;
      const p = pointerSession; pointerSession = null;
      p.node.classList.remove('is-dragging');
      if (p.active) finishDrag();
    });
    flavours.forEach(flavour => {
      const card = document.createElement('button');
      card.type = 'button'; card.className = 'hj-vtray__choice'; card.dataset.flavour = flavour.id;
      card.style.setProperty('--flavour-color', flavour.color);
      card.title = strings.add;
      const img = new Image(); img.src = flavour.url; img.alt = ''; img.width = 365; img.height = 365; img.draggable = false;
      const name = document.createElement('span'); name.className = 'hj-vtray__choice-name'; name.textContent = flavour.name;
      const badge = document.createElement('span'); badge.className = 'hj-vtray__quantity'; badge.setAttribute('aria-hidden','true');
      card.append(img, name, badge);
      card.addEventListener('click', () => {
        if (busy || justDragged) return;
        const i = state.indexOf(null); if (i < 0) return;
        selected = flavour.id; save(); state[i] = selected; render();
      });
      makeDraggable(card, () => state.every(Boolean) ? null : ({kind:'new', flavour:flavour.id}));
      const wrap = document.createElement('div'); wrap.className = 'hj-vtray__choice-wrap';
      const minus = document.createElement('button'); minus.type = 'button'; minus.className = 'hj-vtray__minus';
      minus.textContent = '−'; minus.hidden = true;
      minus.setAttribute('aria-label', journey.remove.replace('[flavour]', flavour.name));
      minus.addEventListener('click', () => {
        if(busy)return;
        const index = state.lastIndexOf(flavour.id); if(index < 0)return;
        save(); state[index] = null; render();
        if(minus.hidden)card.focus({preventScroll:true});
      });
      wrap.append(card,minus); picker.append(wrap); cards.push(card);
    });
    rows.forEach((row, r) => row.slice(3).forEach((x,c) => {
      const i = r*3+c;
      const button = document.createElement('button');
      button.type = 'button'; button.className = 'hj-vtray__slot';
      const potScale = row[1] * 1.62 / 344;
      const potTilt = [0.82,0.865,0.91,0.955,1][r];
      const rimInset = [8,9,10,11,12][r];
      const potLeft = (row[1] / 2 - 176 * potScale) / row[1] * 100;
      const potTop = (row[2] - rimInset - 250 * potScale) / row[2] * 100;
      button.style.cssText = `--pot-tilt:${potTilt};--pot-left:${potLeft}%;--pot-top:${potTop}%;--x:${(x-150)/12}%;--y:${(row[0]-70)/14}%;--w:${row[1]/12}%;--h:${row[2]/14}%;--z:${r+1}`;
      button.addEventListener('click', () => {
        if (busy || justDragged) return;
        if(!state[i])return; save(); state[i] = null; render();
      });
      button.addEventListener('keydown', e => {
        if ((e.key === 'Delete' || e.key === 'Backspace') && state[i]) {
          e.preventDefault(); save(); state[i] = null; render();
        }
      });
      makeDraggable(button, () => state[i] ? ({kind:'move', index:i, flavour:state[i]}) : null);
      holder.append(button); buttons.push(button);
    }));
    // The whole tray is a drop target. Gaps and occupied holes snap to the
    // nearest available opening, rather than requiring a hit on the hole.
    function nearestSpace(x, y) {
      const area = stage.getBoundingClientRect();
      const margin = 24;
      if (x < area.left-margin || x > area.right+margin || y < area.top-margin || y > area.bottom+margin) return -1;
      let nearest = -1; let distance = Infinity;
      buttons.forEach((button,i) => {
        if (state[i] && !(dragSource.kind === 'move' && dragSource.index === i)) return;
        const rect = button.getBoundingClientRect();
        const d = Math.hypot(x - (rect.left + rect.width/2), y - (rect.top + rect.height/2));
        if (d < distance) { distance = d; nearest = i; }
      });
      return nearest;
    }
    function commitDrop(target, source, outside) {
      if (target >= 0 && !(source.kind === 'move' && source.index === target)) {
        save();
        if (source.kind === 'move') state[source.index] = null;
        state[target] = source.flavour; render();
      } else if (target < 0 && source.kind === 'move' && outside) {
        save(); state[source.index] = null; render();
      }
    }
    function createPot(i, flavour, animate) {
      const ns = 'http://www.w3.org/2000/svg';
      function el(tag, attrs) {
        const node = document.createElementNS(ns, tag);
        Object.entries(attrs).forEach(([key, value]) => node.setAttribute(key, value));
        return node;
      }
      const clipId = root.getAttribute('aria-labelledby') + '-seat-' + i;
      const svg = el('svg', {viewBox:'0 0 344 344', width:'344', height:'344',
        class:'hj-vtray__pot' + (animate && !reduced.matches ? ' is-dropping' : ''),
        'data-flavour':flavour.id, 'aria-hidden':'true', focusable:'false'});
      const defs = el('defs', {});
      const clip = el('clipPath', {id:clipId, clipPathUnits:'userSpaceOnUse'});
      clip.append(el('path', {d:'M -344 -344 H 688 V 200 H 270 C 264 229 226 250 176 250 C 141 250 115 240 97 225 C 75 235 50 232 34 215 H -344 Z'}));
      defs.append(clip);
      const group = el('g', {'clip-path':'url(#' + clipId + ')'});
      // New exports have 7px/8px extra padding; normalise without editing the artwork.
      group.append(el('image', {href:flavour.url, x:flavour.x, y:flavour.y, width:flavour.size, height:flavour.size, class:'hj-vtray__pot-art'}));
      svg.append(defs, group);
      svg.addEventListener('animationend', () => svg.classList.remove('is-dropping'), {once:true});
      return svg;
    }
    function land(added) {
      clearTimeout(landTimer);
      if (reduced.matches || !added.length) return;
      landTimer = setTimeout(() => {
        if (reduced.matches || !added.some(([i,id]) => state[i] === id)) return;
        if (impact) impact.cancel();
        // Less than one CSS pixel: a little weight, with no layout movement.
        impact = stage.animate([
          {transform:'translateY(0)'},
          {transform:'translateY(.65px)', offset:.35},
          {transform:'translateY(0)'}
        ], {duration:150, easing:'ease-out'});
      }, 196);
    }
    function render(animate = true) {
      const total = state.filter(Boolean).length;
      root.classList.toggle('has-shots',total > 0);
      const added = [];
      buttons.forEach((button,i) => {
        const id = state[i];
        button.setAttribute('aria-label', id ? label(strings.remove_slot, i+1, byId[id].name) : journey.empty_space.replace('[number]',i+1));
        button.draggable = false; button.disabled = busy || !id; button.classList.toggle('is-filled', Boolean(id));
        let existing = button.querySelector('.hj-vtray__pot');
        if (id) {
          clearTimeout(button.removeTimer); button.classList.remove('is-removing');
          if (existing && existing.dataset.flavour !== id) { existing.remove(); existing = null; }
          if (!existing) { button.append(createPot(i, byId[id], animate)); added.push([i,id]); }
        } else if (existing && !button.classList.contains('is-removing')) {
          if (animate && !reduced.matches) {
            button.classList.add('is-removing');
            button.removeTimer = setTimeout(() => {
              if (!state[i]) existing.remove();
              button.classList.remove('is-removing');
            }, 140);
          } else existing.remove();
        }
      });
      const revealDownload = total === 15 && download.hidden;
      download.hidden = total !== 15;
      if (revealDownload && animate && !matchMedia('(prefers-reduced-motion: reduce)').matches) {
        download.animate([{opacity:0},{opacity:1}], {duration:500,easing:'ease-out'});
        requestAnimationFrame(() => {
          if (!download.hidden) document.dispatchEvent(new CustomEvent('hj:tray-sparkles',{detail:{target:download}}));
        });
      }
      if (total !== 15) clearTimeout(completionScrollTimer);
      if (revealDownload && animate && !completionHandled) {
        completionHandled = true;
        clearTimeout(completionScrollTimer);
        completionScrollTimer = setTimeout(() => {
          if (!root.isConnected || state.some(id=>!id) || shareDialog.open || root.classList.contains('is-writing-gift')) return;
          const target = mobileLayout.matches ? root.querySelector('.hj-vtray__sizes') : (giftToggle.checked ? root.querySelector('[data-gift-fields]') : buy);
          root.classList.add('is-purchasing');
          const box = target.getBoundingClientRect();
          const stickyHeight = mobileLayout.matches ? root.querySelector('.hj-vtray__visual-stack').getBoundingClientRect().height : 0;
          const availableHeight = Math.max(0,innerHeight-stickyHeight-24);
          const top = mobileLayout.matches
            ? scrollY + box.top - stickyHeight - 16
            : scrollY + box.top - Math.max(24,(availableHeight-Math.min(box.height,availableHeight))/2);
          window.scrollTo({top:Math.max(0,top),behavior:reduced.matches?'auto':'smooth'});
        }, reduced.matches ? 100 : 1000);
      }
      download.disabled = exporting;
      if(total !== 15) downloadStatus.hidden = true;
      count.textContent = `${total} / 15`; progress.value = total;
      status.textContent = total === 15 ? strings.full : total === 0 ? strings.empty : label(strings.remaining, 15-total);
      cards.forEach(card => {
        const qty = state.filter(id => id === card.dataset.flavour).length;
        card.querySelector('.hj-vtray__quantity').textContent = qty || '+';
        card.disabled = busy || total === 15; card.draggable = false;
        const minus = card.parentElement.querySelector('.hj-vtray__minus');
        minus.hidden = qty === 0; minus.disabled = busy;
        card.setAttribute('aria-label', label(strings.add_flavour, qty, byId[card.dataset.flavour].name));
      });
      updatePurchase();
      persistDraft();
      if (animate) land(added);
    }


    // Render from the same coordinates and clipping path as the live tray.
    // Images are fetched only when requested; nothing is uploaded.
    function loadExportImage(url) {
      return new Promise((resolve,reject) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.onload = () => resolve(img);
        img.onerror = () => reject(new Error('Image unavailable'));
        img.src = url;
      });
    }

    const shareDialog = document.createElement('dialog');
    shareDialog.className = 'hj-tray-share';
    shareDialog.setAttribute('aria-label','Make your tray image');
    shareDialog.innerHTML = '<button type="button" class="hj-tray-share__close" aria-label="Close preview">×</button><h2>Personalise your image</h2><div class="hj-tray-share__layout"><div class="hj-tray-share__preview"><p data-share-loading role="status">Preparing your tray…</p></div><div class="hj-tray-share__controls"><fieldset><legend>Choose your message</legend></fieldset><label class="hj-tray-share__custom" hidden>Your message<input type="text" maxlength="40" placeholder="Your tray. Your words." data-share-custom><small>Up to 40 characters</small></label><button type="button" class="hj-tray-share__save" disabled>Download image</button><p data-share-error role="status"></p></div></div>';
    root.append(shareDialog);
    const headlines = ['I’ve sorted the shots. Who’s coming?','Your place or mine? I’m bringing these.','Birthday crew, these are coming with me.','We’re overdue a night together.'];
    const shareChoices = shareDialog.querySelector('fieldset');
    const customField = shareDialog.querySelector('.hj-tray-share__custom');
    const customInput = shareDialog.querySelector('[data-share-custom]');
    const shareSave = shareDialog.querySelector('.hj-tray-share__save');
    const shareLoading = shareDialog.querySelector('[data-share-loading]');
    const shareError = shareDialog.querySelector('[data-share-error]');
    const poster = document.createElement('canvas');
    poster.width = 1500; poster.height = 1500;
    poster.setAttribute('role','img');
    poster.setAttribute('aria-label','Preview of your square tray image');
    poster.hidden = true;
    shareDialog.querySelector('.hj-tray-share__preview').append(poster);
    let drawPoster = null, shareFile = null, posterVersion = 0;
    const nativeShare = document.createElement('button'); nativeShare.type='button'; nativeShare.className='hj-tray-share__native'; nativeShare.textContent=journey.share_image; nativeShare.hidden=true;
    const mixShare = document.createElement('button'); mixShare.type='button'; mixShare.className='hj-tray-share__mix'; mixShare.textContent=journey.share_mix;
    const linkField = document.createElement('input'); linkField.type='text'; linkField.readOnly=true; linkField.className='hj-tray-share__link'; linkField.hidden=true; linkField.setAttribute('aria-label',journey.share_mix);
    const secondaryActions=document.createElement('div');secondaryActions.className='hj-tray-share__secondary';
    shareSave.before(nativeShare,secondaryActions);secondaryActions.append(shareSave,mixShare);secondaryActions.after(linkField);
    nativeShare.addEventListener('click',async()=>{
      if(!shareFile)return;
      trackTrayImage('tray_image_share_open');
      try{await navigator.share({files:[shareFile],title:journey.share_title});trackTrayImage('tray_image_share_returned');}
      catch(error){if(error.name!=='AbortError')shareError.textContent=journey.share_error;}
    });
    function mixLink(){
      const url=new URL(location.href);url.search='';url.hash=new URLSearchParams({mix:state.join(','),pack:String(Number(currentVariant()?.dataset.shots)||15)}).toString();return url.href;
    }
    mixShare.addEventListener('click',async()=>{
      const url=mixLink();
      try{await navigator.clipboard.writeText(url);trackTrayImage('tray_image_link_copy');shareError.textContent=journey.copied;linkField.hidden=true;}
      catch(error){shareError.textContent=journey.copy_manual;linkField.value=url;linkField.hidden=false;linkField.focus();linkField.select();}
    });
    function selectedHeadline() {
      const value = shareChoices.querySelector('input:checked').value;
      return value === 'custom' ? customInput.value.trim() : headlines[Number(value)];
    }
    function refreshPoster() {
      const custom = shareChoices.querySelector('input:checked').value === 'custom';
      customField.hidden = !custom;
      shareSave.disabled = !drawPoster || !selectedHeadline();
      nativeShare.hidden=true;shareFile=null;
      const version=++posterVersion;
      if(drawPoster){
        drawPoster(selectedHeadline() || 'Your tray. Your words.');
        if(selectedHeadline() && navigator.canShare && navigator.share && typeof File!=='undefined')poster.toBlob(blob=>{
          if(!blob || version!==posterVersion)return;
          const file=new File([blob],'my-hard-jelly-tray.png',{type:'image/png'});
          if(navigator.canShare({files:[file]})){shareFile=file;nativeShare.hidden=false;}
        },'image/png');
      }
    }
    [...headlines,'Write your own'].forEach((text,index) => {
      const label = document.createElement('label');
      const input = document.createElement('input');
      input.type = 'radio'; input.name = 'tray-headline-' + root.getAttribute('aria-labelledby');
      input.value = index === headlines.length ? 'custom' : String(index);
      input.checked = index === 0;
      const span = document.createElement('span'); span.textContent = text;
      if(index>0&&index<headlines.length)label.dataset.desktopMessage='true';
      label.append(input,span); shareChoices.append(label);
      input.addEventListener('change',refreshPoster);
    });
    function syncMobileMessages(){
      const closeButton=shareDialog.querySelector('.hj-tray-share__close');
      if(mobileLayout.matches)shareDialog.querySelector('.hj-tray-share__preview').prepend(closeButton);
      else shareDialog.prepend(closeButton);
      if(mobileLayout.matches&&shareChoices.querySelector('[data-desktop-message] input:checked')){
        shareChoices.querySelector('input[value="0"]').checked=true;
        refreshPoster();
      }
    }
    mobileLayout.addEventListener('change',syncMobileMessages);
    customInput.addEventListener('input',refreshPoster);
    shareDialog.querySelector('.hj-tray-share__close').addEventListener('click',()=>shareDialog.close());
    shareDialog.addEventListener('click',event=>{if(event.target===shareDialog){const b=shareDialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)shareDialog.close();}});
    shareDialog.addEventListener('close',()=>download.focus({preventScroll:true}));
    shareSave.addEventListener('click',async()=>{
      if(!drawPoster || !selectedHeadline() || shareSave.disabled)return;
      shareSave.disabled = true; shareSave.textContent = 'Saving…'; shareError.textContent = '';
      try {
        const blob = await new Promise((resolve,reject)=>poster.toBlob(value=>value?resolve(value):reject(new Error('Export unavailable')),'image/png'));
        const url = URL.createObjectURL(blob), link = document.createElement('a');
        link.href=url; link.download='my-hard-jelly-tray.png';
        document.body.append(link); link.click(); link.remove();
        trackTrayImage('tray_image_download');
        setTimeout(()=>URL.revokeObjectURL(url),60000);
      } catch(error) {shareError.textContent='Couldn’t save your image. Please try again.';}
      finally {shareSave.textContent='Download image';shareSave.disabled=!selectedHeadline();}
    });
    download.addEventListener('click',async()=>{
      if(exporting || state.some(id=>!id))return;
      clearTimeout(completionScrollTimer);
      const snapshot=state.slice();
      exporting=true;download.disabled=true;drawPoster=null;shareSave.disabled=true;
      nativeShare.hidden=true;shareFile=null;posterVersion++;linkField.hidden=true;
      poster.hidden=true;shareLoading.hidden=false;shareLoading.textContent='Preparing your tray…';shareError.textContent='';
      syncMobileMessages();
      shareDialog.showModal();
      trackTrayImage('tray_image_preview');
      try {
        await Promise.all([document.fonts.load('700 70px Poppins'), document.fonts.load('600 52px Poppins')]);
        const ids = [...new Set(snapshot)];
        const loaded = await Promise.all([
          loadExportImage(root.querySelector('.hj-vtray__tray').dataset.exportSrc),
          ...ids.map(id => loadExportImage(byId[id].url)),
          loadExportImage('https://cdn.shopify.com/s/files/1/0614/9829/4434/files/Untitled-2_copy_c977ec7a-7b12-4459-b80f-52de535c6c95.png?v=1792672963')
        ]);
        const images = Object.fromEntries(ids.map((id,i) => [id,loaded[i+1]]));
        const canvas = document.createElement('canvas');
        canvas.width = 1500; canvas.height = 1500;
        const ctx = canvas.getContext('2d');
        if(!ctx) throw new Error('Canvas unavailable');
        ctx.save();
        ctx.drawImage(loaded[0],0,0,1500,1500);
        const trayPixels=ctx.getImageData(0,0,1500,1500).data;
        const clip = new Path2D('M -344 -344 H 688 V 200 H 270 C 264 229 226 250 176 250 C 141 250 115 240 97 225 C 75 235 50 232 34 215 H -344 Z');
        snapshot.forEach((id,i) => {
          const row = rows[Math.floor(i/3)], r = Math.floor(i/3);
          const x = row[3+i%3], y = row[0], w = row[1], h = row[2];
          // Soft contact shadow behind each seated pot.
          ctx.save();
          ctx.translate(x+w*.1348,y+h*.2285);
          ctx.scale(w*.56,h*.435);
          const shadow = ctx.createRadialGradient(0,0,0,0,0,1);
          shadow.addColorStop(0,'#21112438');
          shadow.addColorStop(.38,'#21112423');
          shadow.addColorStop(.6,'#2111240d');
          shadow.addColorStop(.75,'#21112400');
          ctx.fillStyle = shadow; ctx.fillRect(-1,-1,2,2); ctx.restore();
          const scale = w*1.62/344, tilt = [.82,.865,.91,.955,1][r];
          const rim = [8,9,10,11,12][r], f = byId[id];
          ctx.save();
          ctx.translate(x,y+h/2-rim);
          ctx.scale(scale,scale*tilt);
          ctx.translate(-176,-250);
          ctx.clip(clip);
          ctx.drawImage(images[id],f.x,f.y,f.size,f.size);
          ctx.restore();
        });
        ctx.restore();


        const art = poster.getContext('2d');
        if(!art)throw new Error('Canvas unavailable');
        const pixels=ctx.getImageData(0,0,1500,1500).data;
        let left=1500,top=1500,right=0,bottom=0;
        for(let y=0;y<1500;y++)for(let x=0;x<1500;x++){
          if(pixels[(y*1500+x)*4+3]>10){left=Math.min(left,x);right=Math.max(right,x);top=Math.min(top,y);bottom=Math.max(bottom,y);}
        }
        const width=right-left+1,height=bottom-top+1,fit=Math.min(1050/width,1140/height);
        // Crisp sticker silhouette, excluding the original soft contact shadows.
        const stickerMask=document.createElement('canvas');stickerMask.width=stickerMask.height=1500;
        const maskCtx=stickerMask.getContext('2d'),maskPixels=maskCtx.createImageData(1500,1500);
        for(let p=0;p<pixels.length;p+=4){maskPixels.data[p]=255;maskPixels.data[p+1]=255;maskPixels.data[p+2]=255;maskPixels.data[p+3]=trayPixels[p+3]>128?255:0;}
        maskCtx.putImageData(maskPixels,0,0);
        const stickerBlack=document.createElement('canvas');stickerBlack.width=stickerBlack.height=1500;
        const blackCtx=stickerBlack.getContext('2d');blackCtx.drawImage(stickerMask,0,0);blackCtx.globalCompositeOperation='source-in';blackCtx.fillStyle='#000';blackCtx.fillRect(0,0,1500,1500);
        drawPoster = headline => {
          // Smooth colour mesh sampled from the approved gradient reference.
          const edges=[
            [[255,32,100],[255,132,72],[255,207,49],[142,199,112],[72,194,152]],
            [[248,78,144],[227,85,143],[182,79,168],[133,69,208],[91,66,243]],
            [[255,32,100],[255,43,99],[254,75,102],[252,89,120],[248,78,144]],
            [[72,194,152],[32,176,213],[10,164,244],[62,120,231],[91,66,243]]
          ];
          if(!drawPoster.gradient){
            const mesh=document.createElement('canvas');mesh.width=mesh.height=192;
            const mc=mesh.getContext('2d'),data=mc.createImageData(192,192);
            const sample=(edge,t,c)=>{const pos=t*4,i=Math.min(3,Math.floor(pos)),f=pos-i;return edge[i][c]*(1-f)+edge[i+1][c]*f;};
            for(let y=0;y<192;y++)for(let x=0;x<192;x++){
              const u=x/191,v=y/191,p=(y*192+x)*4;
              for(let c=0;c<3;c++){
                const corners=(1-u)*(1-v)*edges[0][0][c]+u*(1-v)*edges[0][4][c]+(1-u)*v*edges[1][0][c]+u*v*edges[1][4][c];
                data.data[p+c]=(1-v)*sample(edges[0],u,c)+v*sample(edges[1],u,c)+(1-u)*sample(edges[2],v,c)+u*sample(edges[3],v,c)-corners;
              }
              data.data[p+3]=255;
            }
            mc.putImageData(data,0,0);drawPoster.gradient=mesh;
          }
          art.drawImage(drawPoster.gradient,0,0,1500,1500);
          art.save();art.translate(760,660);art.rotate(.075);
          const drawSticker=(source,dx,dy)=>art.drawImage(source,left,top,width,height,-width*fit/2+dx,-height*fit/2+dy,width*fit,height*fit);
          // Solid offset black backing and a clean white cut-out edge.
          drawSticker(stickerBlack,-17,17);
          for(let step=0;step<=5;step+=1){
            drawSticker(stickerMask,step,0);drawSticker(stickerMask,step,step);
          }
          drawSticker(canvas,0,0);
          art.restore();
          art.save();art.shadowColor='#24103055';art.shadowBlur=5;art.shadowOffsetX=0;art.shadowOffsetY=3;art.translate(1444,56);art.rotate(Math.PI/2);
          art.fillStyle='#fff';art.textAlign='left';art.textBaseline='middle';
          art.font='500 46px Poppins';const ctaPrefix='MAKE YOURS AT ',prefixWidth=art.measureText(ctaPrefix).width;
          art.font='600 46px Poppins';const urlWidth=art.measureText('HARDJELLY.CO.UK').width;
          const ctaWidth=prefixWidth+urlWidth;art.scale(Math.min(1,720/ctaWidth),1);
          art.font='500 46px Poppins';art.fillText(ctaPrefix,0,0);
          art.font='600 46px Poppins';art.fillText('HARDJELLY.CO.UK',prefixWidth,0);art.restore();
          const boughtGraphic=loaded[loaded.length-1];
          art.save();art.shadowColor='#24103055';art.shadowBlur=6;art.shadowOffsetX=0;art.shadowOffsetY=3;
          art.drawImage(boughtGraphic,10,45,504,504*boughtGraphic.naturalHeight/boughtGraphic.naturalWidth);art.restore();
          let size=80;
          art.font='700 '+size+'px Poppins';
          const measured=art.measureText(headline).width;
          if(measured>1360)size*=1360/measured;
          art.fillStyle='#fff';art.textAlign='center';art.textBaseline='alphabetic';art.font='700 '+size+'px Poppins';
          art.save();art.shadowColor='#24103055';art.shadowBlur=6;art.shadowOffsetX=0;art.shadowOffsetY=3;
          const trayBottom=660+(Math.abs(width*fit*Math.sin(.075))+Math.abs(height*fit*Math.cos(.075)))/2;
          const textMetrics=art.measureText(headline);
          const headlineY=(trayBottom+1500)/2+(textMetrics.actualBoundingBoxAscent-textMetrics.actualBoundingBoxDescent)/2;
          art.fillText(headline,750,headlineY,1360);art.restore();
          
          poster.setAttribute('aria-label','Your tray image: '+headline);
        };
        shareLoading.hidden=true;poster.hidden=false;refreshPoster();
      } catch(error){shareLoading.textContent='Couldn’t prepare your tray. Close this preview and try again.';}
      finally{exporting=false;download.disabled=false;}
    });

    function currentVariant() { return form.querySelector('[name="id"]:checked')?.closest('label'); }
    function updatePurchase() {
      const variant = currentVariant();
      const total = state.filter(Boolean).length;
      const shots = Number(variant?.dataset.shots) || 15;
      const trays = shots / 15;
      const mix = flavours.map(f => ({name:f.name, count:state.filter(id => id === f.id).length})).filter(f => f.count);
      selection.value = mix.map(f => f.name + ': ' + f.count).join(', ');
      root.querySelector('[data-price-amount]').textContent = variant?.dataset.price || '';
      const base = Number(form.querySelector('[data-shots="15"]')?.dataset.priceCents) || 0;
      const saving = Math.max(0,base * trays - Number(variant?.dataset.priceCents));
      const savingNode = root.querySelector('[data-pack-saving]');
      savingNode.hidden = saving === 0;
      const money = new Intl.NumberFormat(document.documentElement.lang || 'en-GB',{style:'currency',currency:root.dataset.currency || 'GBP'});
      savingNode.textContent = journey.saving.replace('[amount]',money.format(saving/100)).replace('[trays]',trays);
      root.querySelector('[data-overview]').textContent = journey.overview.replace('[shots]',shots).replace('[price]',variant?.dataset.price || '');
      root.querySelector('[data-pack-repeat]').textContent = trays === 1 ? purchaseStrings.single : purchaseStrings.repeat.replace('[trays]', trays);
      root.querySelector('[data-pack-details]').hidden = total === 0;
      root.querySelector('[data-pack-heading]').textContent = purchaseStrings.pack.replace('[shots]', shots);
      root.querySelector('[data-pack-totals]').replaceChildren(...mix.map(f => {
        const li = document.createElement('li');
        li.textContent = f.name + ': ' + f.count * trays + (trays > 1 ? purchaseStrings.total.replace('[count]', f.count) : '');
        return li;
      }));
      const available = variant?.dataset.available === 'true';
      buy.disabled = busy || total !== 15 || !available;
      buy.textContent = busy ? purchaseStrings.adding : !available ? purchaseStrings.sold_out : total === 15 ? purchaseStrings.add : purchaseStrings.finish;
      form.querySelectorAll('[name="id"]').forEach(input => {
        input.disabled = busy || input.closest('label').dataset.available !== 'true';
        input.closest('label').classList.toggle('is-selected', input.checked);
      });
    }
    form.addEventListener('change', event => {
      if(event.target.name !== 'id') return;
      error.hidden = true; success.hidden = true;
      updatePurchase(); persistDraft();
    });
    form.addEventListener('submit', async event => {
      event.preventDefault();
      if(busy) return;
      error.hidden = true; success.hidden = true;
      updatePurchase();
      if(state.filter(Boolean).length !== 15) { error.textContent = purchaseStrings.incomplete; error.hidden = false; return; }
      if(currentVariant()?.dataset.available !== 'true') { error.textContent = purchaseStrings.sold_out; error.hidden = false; return; }
      const data = new FormData(form);
      busy = true; render(false);
      try {
        const response = await fetch((window.Shopify?.routes?.root || '/') + 'cart/add.js', {method:'POST', headers:{Accept:'application/json'}, body:data});
        const result = await response.json();
        if(!response.ok) throw new Error(typeof result.description === 'string' ? result.description : purchaseStrings.error);
        success.hidden = false;
        try{sessionStorage.removeItem(giftKey);}catch(error){}
        if(window.HJCart) {
          try { await window.HJCart.getCart(); window.HJCart.open(); } catch(cartError) { success.hidden = false; }
        }
      } catch(fetchError) {
        error.textContent = fetchError.message === 'Failed to fetch' ? purchaseStrings.error : fetchError.message || purchaseStrings.error;
        error.hidden = false;
      } finally {
        busy = false; render(false);
      }
    });

    function persistDraft(){
      if(loadingDraft)return;
      try{
        if(state.some(Boolean))localStorage.setItem(draftKey,JSON.stringify({version:1,at:Date.now(),state,variant:currentVariant()?.querySelector('input').value}));
        else localStorage.removeItem(draftKey);
      }catch(error){}
    }
    function persistGift(){
      if(loadingDraft)return;
      try{
        if(!giftToggle.checked){sessionStorage.removeItem(giftKey);return;}
        const fields={};form.querySelectorAll('[data-gift-fields] input,[data-gift-fields] textarea').forEach(input=>fields[input.name]=input.value);
        sessionStorage.setItem(giftKey,JSON.stringify({at:Date.now(),fields}));
      }catch(error){}
    }
    function applyVariant(value,byShots=false){
      const choice=[...form.querySelectorAll('[name="id"]')].find(input=>!input.disabled && (byShots ? input.closest('label').dataset.shots===value : input.value===value));
      if(choice)choice.checked=true;
    }
    let imported=false;
    try{
      const params=new URLSearchParams(location.hash.slice(1)), mix=(params.get('mix')||'').split(',');
      if(mix.length===15 && mix.every(id=>Object.hasOwn(byId,id))){state=mix;applyVariant(params.get('pack'),true);imported=true;completionHandled=true;}
      else{
        const draft=JSON.parse(localStorage.getItem(draftKey)||'null');
        if(draft?.version===1 && Date.now()-draft.at<14*86400000 && Array.isArray(draft.state) && draft.state.length===15 && draft.state.every(id=>id===null || Object.hasOwn(byId,id))){
          state=draft.state;applyVariant(draft.variant);completionHandled=state.every(Boolean);
        }
      }
      if(state.some(Boolean)){
        const notice=root.querySelector('[data-restored]');notice.textContent=imported?journey.shared:journey.restored;notice.hidden=false;
        setTimeout(()=>notice.hidden=true,6000);
      }
      if(!imported){
        const draft=JSON.parse(sessionStorage.getItem(giftKey)||'null');
        if(draft?.fields && Date.now()-draft.at<2*3600000){
          giftToggle.checked=true;
          form.querySelectorAll('[data-gift-fields] input,[data-gift-fields] textarea').forEach(input=>{if(typeof draft.fields[input.name]==='string')input.value=draft.fields[input.name].slice(0,input.maxLength);});
          requestAnimationFrame(()=>giftToggle.dispatchEvent(new Event('change',{bubbles:true})));
        }
      }
    }catch(error){}
    loadingDraft=false;
    const writeNote=root.querySelector('[data-write-note]');
    function updateGiftLink(){writeNote.hidden=!giftToggle.checked;persistGift();}
    giftToggle.addEventListener('change',updateGiftLink);updateGiftLink();
    form.addEventListener('input',event=>{if(event.target.closest('[data-gift-fields]'))persistGift();});
    function cancelCompletion(){clearTimeout(completionScrollTimer);}
    root.addEventListener('pointerdown',cancelCompletion,true);
    root.addEventListener('keydown',cancelCompletion,true);
    window.addEventListener('wheel',cancelCompletion,{passive:true});
    window.addEventListener('touchstart',cancelCompletion,{passive:true});
    const purchase=root.querySelector('.hj-vtray__purchase');
    function updateSticky(){
      const visual=root.querySelector('.hj-vtray__visual');
      root.classList.toggle('is-purchasing',mobileLayout.matches && purchase.getBoundingClientRect().top<visual.offsetHeight+48);
    }
    let positionFrame=0;
    function queuePosition(){if(!positionFrame)positionFrame=requestAnimationFrame(()=>{positionFrame=0;updateSticky();});}
    window.addEventListener('scroll',queuePosition,{passive:true});window.addEventListener('resize',queuePosition,{passive:true});
    root.addEventListener('focusin',event=>{if(event.target.closest('[data-gift-fields]'))root.classList.add('is-writing-gift');});
    root.addEventListener('focusout',()=>requestAnimationFrame(()=>{root.classList.toggle('is-writing-gift',Boolean(document.activeElement?.closest('[data-gift-fields]')));queuePosition();}));
    writeNote.addEventListener('click',()=>{
      cancelCompletion();root.classList.add('is-writing-gift','is-purchasing');
      const message=root.querySelector('[data-gift-message]');message.focus({preventScroll:true});message.scrollIntoView({block:'center',behavior:reduced.matches?'auto':'smooth'});
    });
    render(false);queuePosition();
  }
  document.querySelectorAll('[data-hj-vtray]').forEach(init);
  document.addEventListener('shopify:section:load', e => e.target.querySelectorAll('[data-hj-vtray]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-404"] && !Shopify.designMode) return;
  try {
    
function initHJ404(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  root.querySelectorAll('.hj-card__form').forEach(form=>{
    const price=form.querySelector('[data-card-price]');
    const shipping=price?.querySelector('em')?.textContent||'';
    form.addEventListener('change',event=>{
      if(event.target.name!=='id')return;
      form.querySelectorAll('.hj-card__variant').forEach(label=>label.classList.toggle('is-selected',label.querySelector('input').checked));
      const label=event.target.closest('.hj-card__variant');
      if(!price||!label)return;
      const value=label.dataset.price||'';
      const amount=shipping&&value.endsWith(shipping)?value.slice(0,value.length-shipping.length).trim():value;
      if(window.HJTransitionPrice)window.HJTransitionPrice(price,amount,label.dataset.priceCents);
    });
    form.addEventListener('submit',async event=>{
      event.preventDefault();
      const button=form.querySelector('button[type="submit"]');
      if(!button)return;
      button.disabled=true;
      try{
        const response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        if(!response.ok)throw new Error();
        await response.json();
        if(window.HJCart){await window.HJCart.getCart();window.HJCart.open()}
        else location.href='/cart';
      }catch(error){
        button.textContent='Try again';
        setTimeout(()=>button.textContent='Add to Cart',1800);
      }finally{button.disabled=false}
    });
  });
}
document.querySelectorAll('.hj-404').forEach(initHJ404);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.hj-404').forEach(initHJ404));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"] && !Shopify.designMode) return;
  try {
    
function initHJArticleImages(scope){
  scope.querySelectorAll('.hj-article__content img[alt]').forEach(img=>{
    if(img.dataset.hjPositioned)return;
    const alt=(img.getAttribute('alt')||'').trim();
    const match=alt.match(/^(right|left)\s*:\s*(.*)$/i);
    if(!match)return;
    img.dataset.hjPositioned='true';
    const side=match[1].toLowerCase();
    img.classList.add('hj-article-img--'+side);
    img.setAttribute('alt',match[2]);
    const wrapper=img.closest('figure,p,div');
    if(wrapper&&wrapper!==img.closest('.hj-article__content'))wrapper.classList.add('hj-article-wrap--'+side);
  });
}
initHJArticleImages(document);
document.addEventListener('shopify:section:load',event=>initHJArticleImages(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart"]) return;
  try {
    

function initHJCartPage(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  let busy=false;
  async function update(row,quantity){
    if(busy)return;
    const input=row.querySelector('[name="updates[]"]');
    if(!Number.isInteger(quantity)||quantity<0){input.value=input.dataset.originalQuantity;return}
    busy=true;
    root.setAttribute('aria-busy','true');
    const controls=[...root.querySelectorAll('button,input')];
    const enabled=controls.filter(control=>!control.disabled);
    enabled.forEach(control=>control.disabled=true);
    const error=root.querySelector('[data-cart-page-error]');
    error.hidden=true;
    try{
      const response=await fetch(root.dataset.changeUrl,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:row.dataset.itemKey,quantity,sections:[root.dataset.sectionId],sections_url:location.pathname})});
      const cart=await response.json();
      if(!response.ok)throw new Error(cart.description||root.dataset.error);
      const html=cart.sections?.[root.dataset.sectionId];
      const next=html&&new DOMParser().parseFromString(html,'text/html').querySelector('[data-cart-page]');
      if(!next){location.reload();return}
      root.innerHTML=next.innerHTML;
      window.HJCart?.render(cart);
      document.dispatchEvent(new CustomEvent('hj:content-updated',{detail:{scope:root}}));
    }catch(failure){
      input.value=input.dataset.originalQuantity;
      error.textContent=failure.message||root.dataset.error;
      error.hidden=false;
    }finally{
      busy=false;
      root.removeAttribute('aria-busy');
      enabled.forEach(control=>control.disabled=false);
    }
  }
  root.addEventListener('submit',event=>{if(busy)event.preventDefault()});
  root.addEventListener('click',event=>{
    const remove=event.target.closest('.hj-cart-page__remove');
    if(remove){event.preventDefault();if(!busy)update(remove.closest('[data-item-key]'),0);return}
    const button=event.target.closest('[data-quantity-step]');
    if(!button||busy)return;
    const input=button.parentElement.querySelector('input');
    const quantity=Math.max(0,(parseInt(input.value,10)||0)+Number(button.dataset.quantityStep));
    input.value=quantity;
    update(button.closest('[data-item-key]'),quantity);
  });
  root.addEventListener('change',event=>{
    if(!event.target.matches('[name="updates[]"]')||busy)return;
    update(event.target.closest('[data-item-key]'),event.target.value===''?NaN:Number(event.target.value));
  });
}
document.querySelectorAll('[data-cart-page]').forEach(initHJCartPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-cart-page]').forEach(initHJCartPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    


function initHJTrayBuilder(form){
  const builder=form?.querySelector('[data-tray-builder]');
  if(!builder)return;
  const inputs=[...builder.querySelectorAll('[data-tray-qty]')];
  const total=()=>inputs.reduce((sum,input)=>sum+(Number(input.value)||0),0);
  const add=form.querySelector('button[type="submit"]');
  const mobile=builder.querySelector('[data-tray-mobile-summary]');
  const mobileBuy=mobile.querySelector('[data-tray-mobile-buy]');
  document.body.append(mobile);
  const chosen=()=>form.querySelector('[name="id"]:checked')?.closest('label');
  const packSize=()=>Math.max(15,parseInt(chosen()?.querySelector('span')?.textContent,10)||15);
  function update(){
    const count=total(),remaining=15-count,size=packSize(),trays=size/15;
    builder.querySelector('[data-tray-count]').textContent=count;
    builder.querySelector('[data-tray-message]').textContent=remaining===0?'Tray complete ✓':remaining===1?'Choose 1 more shot':'Choose '+remaining+' more shots';
    builder.querySelector('.hj-tray-summary').classList.toggle('is-complete',remaining===0);
    builder.querySelector('[name="properties[Flavour selection]"]').value=inputs.filter(input=>Number(input.value)>0).map(input=>input.dataset.name+': '+Number(input.value)).join(', ');
    inputs.forEach(input=>{
      const row=input.closest('.hj-tray-flavour');
      row.querySelector('[data-tray-minus]').disabled=Number(input.value)<=0;
      row.querySelector('[data-tray-plus]').disabled=count>=15;
    });
    add?.classList.toggle('hj-tray-incomplete',count!==15);
    if(count===15)builder.querySelector('[data-tray-error]').hidden=true;
    builder.querySelector('[data-tray-pack-heading]').textContent='Your '+size+'-shot pack';
    builder.querySelector('[data-tray-pack-note]').textContent=trays===1?'(One tray of 15)':'('+trays+' identical trays of 15)';
    const totals=builder.querySelector('[data-tray-pack-totals]');
    totals.replaceChildren(...inputs.filter(input=>Number(input.value)>0).map(input=>{
      const item=document.createElement('li');
      item.textContent=input.dataset.name+': '+(Number(input.value)*trays)+(trays>1?' total ('+input.value+' per tray)':'');
      return item;
    }));

    mobile.querySelector('[data-tray-mobile-count]').textContent=count+' / 15 selected'+(remaining===0?' ✓':'');
    mobile.querySelector('[data-tray-mobile-pack]').textContent=size+' shots';
    mobile.querySelector('[data-tray-mobile-price]').textContent=chosen()?.dataset.price||form.querySelector('[data-price-amount]')?.textContent||'';
    mobileBuy.textContent=remaining===0?'Add to cart':'Finish your tray';
    mobileBuy.disabled=Boolean(add?.disabled);
    syncPosition();
  }
  builder.addEventListener('click',event=>{
    const button=event.target.closest('[data-tray-plus],[data-tray-minus]');
    if(!button||button.disabled)return;
    const input=button.closest('.hj-tray-flavour').querySelector('[data-tray-qty]');
    if(button.hasAttribute('data-tray-plus')){if(total()>=15)return;input.value=Number(input.value)+1}
    else{input.value=Math.max(0,Number(input.value)-1)}
    update();
  });
  form.addEventListener('change',event=>{if(event.target.name==='id')update()});
  function guard(event){
    update();
    if(total()===15)return;
    event.preventDefault();event.stopImmediatePropagation();
    builder.querySelector('[data-tray-error]').hidden=false;
    builder.querySelector('[data-tray-plus]:not(:disabled)')?.focus({preventScroll:true});
  }
  form.addEventListener('submit',guard,true);
  add?.addEventListener('click',guard,true);
  mobileBuy.addEventListener('click',()=>{
    if(add?.disabled)return;
    if(total()!==15){
      builder.querySelector('[data-tray-error]').hidden=false;
      const next=builder.querySelector('[data-tray-plus]:not(:disabled)');
      next?.focus({preventScroll:true});
      next?.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
      return;
    }
    form.requestSubmit(add);
  });
  function syncPosition(){
    const rect=form.getBoundingClientRect(),button=add?.getBoundingClientRect();
    const originalVisible=button&&button.top<innerHeight&&button.bottom>0;
    mobile.hidden=!(matchMedia('(max-width:749px)').matches&&rect.top<innerHeight&&rect.bottom>0&&!originalVisible);
  }
  let frame;
  const schedule=()=>{if(!frame)frame=requestAnimationFrame(()=>{frame=0;syncPosition()})};
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  const observer=new MutationObserver(()=>{mobileBuy.disabled=Boolean(add?.disabled)});
  if(add)observer.observe(add,{attributes:true,attributeFilter:['disabled']});
  builder._hjTrayCleanup=()=>{mobile.remove();observer.disconnect();cancelAnimationFrame(frame);window.removeEventListener('scroll',schedule);window.removeEventListener('resize',schedule)};
  update();
}
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-tray-builder]').forEach(builder=>builder._hjTrayCleanup?.()));

function initHJProductPage(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  const frame=root.querySelector('.hj-product-main-image');
  const thumbs=[...root.querySelectorAll('[data-product-thumb]')];
  const dots=[...root.querySelectorAll('[data-product-dot]')];
  let imageRequest=0;
  async function selectImage(index){
    const thumb=thumbs[index];
    if(!thumb||!frame)return;
    const request=++imageRequest;
    const next=new Image();
    next.src=thumb.dataset.image;
    next.alt=thumb.querySelector('img')?.alt||'';
    try{await next.decode()}catch(error){return}
    if(request!==imageRequest||!root.isConnected)return;
    frame.querySelectorAll('img').forEach(image=>{image.getAnimations().forEach(a=>a.cancel());if(image!==frame.lastElementChild)image.remove()});
    const previous=frame.querySelector('img');
    next.dataset.productMainImage='';
    frame.append(next);
    thumbs.forEach((item,i)=>{item.classList.toggle('is-active',i===index);item.setAttribute('aria-pressed',String(i===index))});
    dots.forEach((item,i)=>{item.classList.toggle('is-active',i===index);item.setAttribute('aria-pressed',String(i===index))});
    const rail=thumb.parentElement;
    rail.scrollTo({left:thumb.offsetLeft-rail.offsetLeft-(rail.clientWidth-thumb.clientWidth)/2,behavior:reduced.matches?'instant':'smooth'});
    if(reduced.matches){previous?.remove();return}
    previous?.animate([{opacity:1},{opacity:0}],{duration:320,easing:'ease-in-out',fill:'forwards'});
    const fade=next.animate([{opacity:0},{opacity:1}],{duration:320,easing:'ease-in-out'});
    fade.finished.then(()=>previous?.remove()).catch(()=>{});
  }
  thumbs.forEach((thumb,index)=>thumb.addEventListener('click',()=>selectImage(index)));
  dots.forEach((dot,index)=>dot.addEventListener('click',()=>selectImage(index)));

  if(frame&&thumbs.length>1){
    let touchStartX=0,touchStartY=0,touchActive=false;
    frame.addEventListener('touchstart',event=>{
      const touch=event.changedTouches[0];
      if(!touch)return;
      touchStartX=touch.clientX;
      touchStartY=touch.clientY;
      touchActive=true;
    },{passive:true});
    frame.addEventListener('touchend',event=>{
      if(!touchActive)return;
      touchActive=false;
      const touch=event.changedTouches[0];
      if(!touch)return;
      const dx=touch.clientX-touchStartX;
      const dy=touch.clientY-touchStartY;
      if(Math.abs(dx)<45||Math.abs(dx)<=Math.abs(dy))return;
      const current=Math.max(0,thumbs.findIndex(item=>item.classList.contains('is-active')));
      const next=dx<0?(current+1)%thumbs.length:(current-1+thumbs.length)%thumbs.length;
      selectImage(next);
    },{passive:true});
  }
  const form=root.querySelector('.hj-product-form'),price=root.querySelector('[data-product-price]');
  initHJTrayBuilder(form);
  // Transfer an optional message drafted on the birthday landing page into
  // the actual product line-item properties before adding it to the cart.
  if(form){
    setTimeout(()=>{
      try{
        const saved=JSON.parse(sessionStorage.getItem('hj-birthday-gift-note-v1')||'null');
        if(!saved||Date.now()-Number(saved.updated||0)>=7200000)return;
        if(!String(saved.to||'').trim()&&!String(saved.from||'').trim()&&!String(saved.message||'').trim())return;
        const toggle=form.querySelector('.hj-product-gift-toggle input');
        if(!toggle)return;
        toggle.checked=true;
        toggle.dispatchEvent(new Event('change',{bubbles:true}));
        const fields=[
          ['properties[Gift to]',saved.to,60],
          ['properties[Gift from]',saved.from,60],
          ['properties[Gift message]',saved.message,300]
        ];
        fields.forEach(([name,value,length])=>{
          const input=[...form.querySelectorAll('input,textarea')].find(el=>el.name===name);
          if(!input)return;
          input.disabled=false;input.value=String(value||'').slice(0,length);
          input.dispatchEvent(new Event('input',{bubbles:true}));
        });
      }catch(error){console.warn('Birthday gift note could not be restored:',error)}
    },0);
  }
  const giftToggle=root.querySelector('.hj-product-gift-toggle input'),writeNote=root.querySelector('[data-product-write-note]');
  if(giftToggle&&writeNote){
    const updateGiftLink=()=>{writeNote.hidden=!giftToggle.checked;};
    giftToggle.addEventListener('change',updateGiftLink);updateGiftLink();
    writeNote.addEventListener('click',()=>{
      const message=form.querySelector('[data-gift-message]');
      message.focus({preventScroll:true});
      message.scrollIntoView({block:'center',behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
    });
  }
  form?.addEventListener('change',event=>{
    if(event.target.name!=='id')return;
    form.querySelectorAll('.hj-product-variants label').forEach(label=>label.classList.toggle('is-selected',label.contains(event.target)));
    const selected=event.target.closest('label');if(price.querySelector('[data-retail-price-was]'))price.querySelector('[data-retail-price-was]').textContent=selected.dataset.priceWas||'';window.HJTransitionPrice(price,selected.dataset.price,selected.dataset.priceCents);
    const unitPrice=form.querySelector('[data-unit-price-display]');
    if(unitPrice){
      const saving=selected.dataset.unitPrice||'',reveal=unitPrice.closest('[data-saving-reveal]');
      if(saving)unitPrice.querySelector('[data-saving-amount]').textContent=saving;
      reveal.classList.toggle('is-visible',Boolean(saving));
      reveal.setAttribute('aria-hidden',String(!saving));
    }
  });
  form?.addEventListener('submit',async event=>{
    if(!window.HJCart)return;
    event.preventDefault();
    const button=form.querySelector('button[type="submit"]'),label=button.textContent;
    button.disabled=true;
    try{
      const response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
      if(!response.ok)throw new Error();
      await response.json();
      if(form.querySelector('.hj-product-gift-toggle input')?.checked){
        try{sessionStorage.removeItem('hj-birthday-gift-note-v1')}catch(error){}
      }
      await window.HJCart.getCart();
      window.HJCart.open();
    }catch(error){
      button.textContent='Try again';
      setTimeout(()=>button.textContent=label,1800);
    }finally{button.disabled=false}
  });

}
document.querySelectorAll('[data-product-page]').forEach(initHJProductPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-product-page]').forEach(initHJProductPage));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["moving-photo-wall"] && !Shopify.designMode) return;
  try {
    
function initHJPhotoWall(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const source=[...root.querySelectorAll('[data-wall-item]')].map(item=>item.innerHTML.trim());
  if(!source.length)return;
  for(let index=source.length-1;index>0;index--){const swap=Math.floor(Math.random()*(index+1));[source[index],source[swap]]=[source[swap],source[index]]}
  const rows=[...root.querySelectorAll('[data-wall-row]')];
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let animations=[],resizeTimer=0,viewportWidth=window.innerWidth;
  const split=[source.filter((item,index)=>index%2===0),source.filter((item,index)=>index%2===1)];
  if(!split[1].length)split[1]=[...split[0]];
  function groupMarkup(items){return '<div class="hj-photo-wall__group">'+items.join('')+'</div>'}
  function build(){
    const progress=animations.map(animation=>animation.effect.getComputedTiming().progress||0);
    animations.forEach(animation=>animation.cancel());animations=[];
    rows.forEach((row,rowIndex)=>{
      const rail=row.querySelector('.hj-photo-wall__rail'),items=split[rowIndex];
      rail.innerHTML=groupMarkup(items);
      const first=rail.firstElementChild;
      let cycle=0;
      while(first.scrollWidth<window.innerWidth+200&&cycle<12){items.forEach(item=>first.insertAdjacentHTML('beforeend',item));cycle++}
      rail.insertAdjacentHTML('beforeend',first.outerHTML);
      rail.lastElementChild.setAttribute('aria-hidden','true');
      if(reduced.matches)return;
      const gap=parseFloat(getComputedStyle(rail).gap)||0,distance=first.scrollWidth+gap,speed=Math.max(8,Number(root.dataset.speed)||28);
      const frames=row.dataset.wallRow==='right'?[{transform:`translate3d(-${distance}px,0,0)`},{transform:'translate3d(0,0,0)'}]:[{transform:'translate3d(0,0,0)'},{transform:`translate3d(-${distance}px,0,0)`}];
      const animation=rail.animate(frames,{duration:distance/speed*1000,iterations:Infinity,easing:'linear'});
      animation.currentTime=(progress[rowIndex]||0)*distance/speed*1000;
      animations.push(animation);
    });
  }
  function handleResize(){
    if(window.innerWidth===viewportWidth)return;
    clearTimeout(resizeTimer);
    resizeTimer=setTimeout(()=>{
      if(window.innerWidth===viewportWidth)return;
      viewportWidth=window.innerWidth;
      build();
    },180);
  }
  reduced.addEventListener('change',build);
  window.addEventListener('resize',handleResize);
  build();
  root.cleanup=()=>{clearTimeout(resizeTimer);animations.forEach(animation=>animation.cancel());window.removeEventListener('resize',handleResize);reduced.removeEventListener('change',build)};
}
document.querySelectorAll('[data-hj-photo-wall]').forEach(initHJPhotoWall);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-photo-wall]').forEach(initHJPhotoWall));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hj-photo-wall]').forEach(root=>root.cleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"] && !Shopify.designMode) return;
  try {
    
function initHJProductInformation(root){if(root.dataset.ready)return;root.dataset.ready='true';const reduced=matchMedia('(prefers-reduced-motion:reduce)');
  root.querySelectorAll('.hj-product-accordions details').forEach(detail=>{
    const summary=detail.querySelector('summary'),panel=detail.querySelector(':scope > div');
    let animation=null,expanded=detail.open;
    summary.addEventListener('click',event=>{
      event.preventDefault();
      const start=detail.getBoundingClientRect().height;
      expanded=!expanded;
      animation?.cancel();
      detail.open=true;
      detail.style.height='auto';
      const border= parseFloat(getComputedStyle(detail).borderTopWidth)+parseFloat(getComputedStyle(detail).borderBottomWidth);
      const end=expanded?detail.getBoundingClientRect().height:summary.getBoundingClientRect().height+border;
      summary.setAttribute('aria-expanded',String(expanded));
      panel.inert=!expanded;
      const finish=()=>{detail.open=expanded;detail.style.height='';animation=null};
      if(reduced.matches){finish();return}
      animation=detail.animate([{height:start+'px'},{height:end+'px'}],{duration:380,easing:'cubic-bezier(.4,0,.2,1)'});
      animation.onfinish=finish;
    });
  });
}
document.querySelectorAll('[data-product-information]').forEach(initHJProductInformation);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-product-information]').forEach(initHJProductInformation));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-review-cards"] && !Shopify.designMode) return;
  try {
    

function initHJMobileReviews(root){
 if(root._reviewCleanup)return;
 const cards=[...root.querySelectorAll(':scope > blockquote')],mobile=matchMedia('(max-width:749px)'),reduced=matchMedia('(prefers-reduced-motion:reduce)');
 let index=0,timer;
 function show(next){index=next;cards.forEach((card,i)=>{card.classList.toggle('is-active',i===index);card.setAttribute('aria-hidden',String(i!==index));card.inert=i!==index})}
 function schedule(){clearInterval(timer);if(mobile.matches&&cards.length>1&&!reduced.matches&&!document.hidden&&!root.matches(':focus-within'))timer=setInterval(()=>show((index+1)%cards.length),4000)}
 function reset(){clearInterval(timer);const active=mobile.matches&&cards.length>1&&!reduced.matches;root.classList.toggle('is-rotating',active);if(active){show(index);schedule()}else cards.forEach(card=>{card.classList.remove('is-active');card.removeAttribute('aria-hidden');card.inert=false})}
 function select(event){const i=cards.indexOf(event.target);if(i>=0&&root.classList.contains('is-rotating')){clearInterval(timer);show(i)}}
 const pause=()=>clearInterval(timer);
 root.addEventListener('focusin',pause);root.addEventListener('focusout',schedule);
 root.addEventListener('shopify:block:select',select);root.addEventListener('shopify:block:deselect',schedule);
 mobile.addEventListener('change',reset);reduced.addEventListener('change',reset);document.addEventListener('visibilitychange',schedule);
 root._reviewCleanup=()=>{clearInterval(timer);mobile.removeEventListener('change',reset);reduced.removeEventListener('change',reset);document.removeEventListener('visibilitychange',schedule)};
 reset();
}
document.querySelectorAll('[data-mobile-review-cards]').forEach(initHJMobileReviews);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-mobile-review-cards]').forEach(initHJMobileReviews));
document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-mobile-review-cards]').forEach(root=>root._reviewCleanup?.()));


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-reviews"] && !Shopify.designMode) return;
  try {
    
function initHJProductReviews(section){
  if(section.dataset.reviewsStarted)return;
  section.dataset.reviewsStarted='true';
  const base=section.dataset.serviceUrl,id=section.dataset.productId;
  const list=section.querySelector('[data-review-list]'),summary=section.querySelector('[data-review-summary]'),status=section.querySelector('[data-review-status]');
  const esc=v=>String(v??'').replace(/[&<>"']/g,c=>({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const stars=rating=>Array.from({length:5},(_,i)=>'<span class="hj-product-review-star" style="--star-fill:'+Math.max(0,Math.min(100,(rating-i)*100))+'%">★</span>').join('');
  if(!base){status.textContent='Reviews are temporarily unavailable.';return}
  const cacheKey='hj-product-reviews-v1:'+base+':'+id;
  let hasCached=list.children.length>0;
  if(hasCached)status.hidden=true;
  const retry=section.querySelector('[data-review-retry]');
  const render=product=>{
    const average=Math.max(0,Math.min(5,Number(product.average)||0)),count=Math.max(0,Number(product.count)||0),display=average.toFixed(1);
    summary.innerHTML='<span class="hj-product-review-stars" aria-hidden="true">'+stars(average)+'</span><strong>'+display+' / 5 · '+count+' reviews</strong>';
    summary.setAttribute('aria-label',display+' out of 5 stars, '+count+' reviews');
    const badge=document.querySelector('.hj-product-rating');
    if(badge){
      badge.setAttribute('aria-label',display+' out of 5 stars, '+count+' reviews');
      badge.querySelectorAll('i').forEach((star,i)=>star.style.setProperty('--fill',Math.max(0,Math.min(100,(average-i)*100))+'%'));
      badge.querySelector('small').innerHTML='<strong>'+display+' / 5</strong> · '+count+' reviews';
    }
    const schema=document.querySelector('[data-hj-structured-data]');
    if(schema){try{
      const data=JSON.parse(schema.textContent),node=data['@graph']?.find(item=>item['@type']==='Product');
      if(node){if(count&&average)node.aggregateRating={'@type':'AggregateRating',ratingValue:Number(display),ratingCount:count,reviewCount:count,bestRating:5,worstRating:1};else delete node.aggregateRating;schema.textContent=JSON.stringify(data)}
    }catch(error){}}
    const reviews=(Array.isArray(product.reviews)?product.reviews:[]).filter(r=>r.review&&Number.isFinite(Date.parse(r.submittedAt))).sort((a,b)=>Date.parse(b.submittedAt)-Date.parse(a.submittedAt)).slice(0,3);
    list.innerHTML=reviews.map(r=>{
      const rating=Math.max(0,Math.min(5,Number(r.rating)||0));
      const date=new Date(r.submittedAt);
      return '<article class="hj-review"><div class="hj-product-review-stars" aria-label="'+rating+' out of 5 stars">'+stars(rating)+'</div><p class="hj-review__meta"><strong>'+esc(r.displayName||'Customer')+'</strong>'+(r.location?' · '+esc(r.location):'')+'<br><time datetime="'+date.toISOString()+'">'+esc(date.toLocaleDateString('en-GB',{day:'numeric',month:'short',year:'numeric',timeZone:'Europe/London'}))+'</time>'+(r.verified?'<span class="hj-review-verified">Verified purchase</span>':'')+'</p><p class="hj-review__text">'+esc(r.review)+'</p></article>';
    }).join('');
    status.hidden=reviews.length>0;
    if(!reviews.length)status.textContent=count?'See the full list for this product’s reviews.':'No published reviews for this product yet.';
  };
  try{
    const cached=JSON.parse(localStorage.getItem(cacheKey)||'null');
    const age=Date.now()-Number(cached?.savedAt);
    if(cached?.product && age>=0 && age<604800000){
      render(cached.product);
      hasCached=true;
      if(age<3600000)return;
    }
  }catch(error){}
  let generation=0,dispose=()=>{};
  const request=()=>{
    dispose();
    const attempt=++generation,callback='hjProductReviews'+Math.random().toString(36).slice(2),script=document.createElement('script');
    let timer;
    retry.hidden=true;
    if(!hasCached){status.hidden=false;status.textContent=status.dataset.reviewLoading;}
    const cleanup=()=>{clearTimeout(timer);script.remove();window[callback]=()=>{};};
    dispose=cleanup;
    const fail=()=>{if(attempt!==generation)return;clearTimeout(timer);status.hidden=false;status.textContent=status.dataset.reviewFailed;retry.hidden=false;};
    timer=setTimeout(fail,15000);
    window[callback]=data=>{
      if(attempt!==generation)return;
      const product=data?.products?.[id];
      if(!product){fail();cleanup();return;}
      render(product);hasCached=true;retry.hidden=true;
      try{
        const reviews=(Array.isArray(product.reviews)?product.reviews:[]).filter(r=>r.review&&Number.isFinite(Date.parse(r.submittedAt))).sort((a,b)=>Date.parse(b.submittedAt)-Date.parse(a.submittedAt)).slice(0,3).map(r=>({rating:r.rating,review:r.review,displayName:r.displayName,location:r.location,submittedAt:r.submittedAt,verified:r.verified}));
        localStorage.setItem(cacheKey,JSON.stringify({savedAt:Date.now(),product:{average:product.average,count:product.count,reviews}}));
      }catch(error){}
      cleanup();
    };
    try{const url=new URL(base);url.searchParams.set('mode','feed');url.searchParams.set('product',id);url.searchParams.set('callback',callback);script.src=url.href;script.async=true;script.fetchPriority='low';script.onerror=()=>{fail();cleanup();};document.head.appendChild(script);}catch(error){fail();cleanup();}
  };
  retry.addEventListener('click',request);
  request();
}
function scheduleHJProductReviews(section){
  if(section.dataset.reviewsScheduled)return;
  section.dataset.reviewsScheduled='true';
  let idleId,timerId,cancelled=false;
  const run=()=>{if(!cancelled&&section.isConnected)initHJProductReviews(section)};
  const schedule=()=>{
    if(cancelled)return;
    if('requestIdleCallback' in window)idleId=requestIdleCallback(run,{timeout:2000});
    else timerId=setTimeout(run,1500);
  };
  if(document.readyState==='complete')schedule();
  else window.addEventListener('load',schedule,{once:true});
  section._hjReviewCleanup=()=>{
    cancelled=true;
    window.removeEventListener('load',schedule);
    if(idleId!==undefined)cancelIdleCallback(idleId);
    clearTimeout(timerId);
  };
}
document.querySelectorAll('[data-product-reviews]').forEach(scheduleHJProductReviews);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-product-reviews]').forEach(scheduleHJProductReviews));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-product-reviews]').forEach(section=>section._hjReviewCleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-form"] && !Shopify.designMode) return;
  try {
    
function initHJReviewForm(section){
  if(section.dataset.reviewReady)return;
  section.dataset.reviewReady='true';
  const frame=section.querySelector('[data-review-frame]');
  const missing=section.querySelector('[data-review-missing]');
  const missingText=section.querySelector('[data-review-missing-text]');
  const base=section.dataset.serviceUrl;
  const hash=new URLSearchParams(location.hash.slice(1));
  const query=new URLSearchParams(location.search);
  const token=hash.get('token')||query.get('token');

  if(!base){
    frame.hidden=true;
    missing.hidden=false;
    missingText.textContent='The review service has not been connected yet.';
    return;
  }

  if(!token){
    frame.hidden=true;
    missing.hidden=false;
    missingText.textContent='This review page only works from the secure link in your review email.';
    return;
  }

  const url=new URL(base);
  url.searchParams.set('mode','form');
  url.searchParams.set('token',token);
  url.hash='token='+encodeURIComponent(token);
  frame.src=url.toString();
}
document.querySelectorAll('[data-review-form]').forEach(initHJReviewForm);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-review-form]').forEach(initHJReviewForm));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["review-loader"] && !Shopify.designMode) return;
  try {
    
function initHJReviewLoader(loader){if(loader.dataset.reviewLoaderStarted)return;loader.dataset.reviewLoaderStarted='true';const base=loader.dataset.serviceUrl,cards=[...document.querySelectorAll('.hj-card')];if(!base||!cards.length)return;const ids=[...new Set(cards.map(card=>card.querySelector('[data-range-product]')?.dataset.rangeProduct).filter(Boolean))],cacheKey='hj-review-summary-v1',stars=rating=>Array.from({length:5},(_,index)=>'<span class="hj-rating-star" style="--star-fill:'+Math.max(0,Math.min(100,(rating-index)*100))+'%">★</span>').join(''),render=data=>{cards.forEach(card=>{const id=card.querySelector('[data-range-product]')?.dataset.rangeProduct,review=data.products&&data.products[id],target=card.querySelector('.hj-card__review');if(!review||!target)return;const displayed=Number(Number(review.average).toFixed(1));target.setAttribute('aria-label',displayed+' out of 5 stars, '+review.count+' reviews');target.innerHTML='<span class="hj-rating-stars" aria-hidden="true">'+stars(displayed)+'</span><span><strong>'+displayed.toFixed(1)+' / 5</strong> · ('+review.count+(review.count===1?' review':' reviews')+')</span>'})};try{const cached=JSON.parse(localStorage.getItem(cacheKey));if(cached&&Date.now()-cached.savedAt<21600000)render(cached.data)}catch(error){}const callback='hjReviewTotals'+Math.random().toString(36).slice(2),script=document.createElement('script'),cleanup=()=>{if(script.isConnected)script.remove();delete window[callback]};window[callback]=data=>{render(data);try{localStorage.setItem(cacheKey,JSON.stringify({savedAt:Date.now(),data:data}))}catch(error){}cleanup()};const url=new URL(base);url.searchParams.set('mode','feed');url.searchParams.set('summary','1');url.searchParams.set('products',ids.join(','));url.searchParams.set('callback',callback);script.async=true;script.src=url.toString();script.onerror=cleanup;document.head.appendChild(script)}function scheduleHJReviewLoader(loader){const start=()=>{if('requestIdleCallback'in window)requestIdleCallback(()=>initHJReviewLoader(loader),{timeout:1500});else setTimeout(()=>initHJReviewLoader(loader),0)};if(document.readyState==='complete')start();else window.addEventListener('load',start,{once:true})}document.querySelectorAll('[data-review-loader]').forEach(scheduleHJReviewLoader);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-review-loader]').forEach(scheduleHJReviewLoader));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-reviews"] && !Shopify.designMode) return;
  try {
    function initHJReviews(root){if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-review]')],dots=[...root.querySelectorAll('[data-dot]')];if(slides.length<2)return;let current=0,timer;function show(next){if(next===current)return;const old=slides[current];old.classList.remove('is-active');old.classList.add('is-exiting');old.setAttribute('aria-hidden','true');current=next;slides[current].classList.remove('is-exiting');slides[current].classList.add('is-active');slides[current].removeAttribute('aria-hidden');dots.forEach((dot,index)=>dot.classList.toggle('is-active',index===current));setTimeout(()=>old.classList.remove('is-exiting'),600)}function start(){clearInterval(timer);timer=setInterval(()=>show((current+1)%slides.length),4000)}dots.forEach(dot=>dot.addEventListener('click',()=>{show(Number(dot.dataset.dot));start()}));document.addEventListener('visibilitychange',()=>document.hidden?clearInterval(timer):start());start()}document.querySelectorAll('[data-hj-reviews]').forEach(initHJReviews);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-reviews]').forEach(initHJReviews));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["send-a-gift"]) return;
  try {
    
function initHJGiftPage(root){
  if(root.dataset.ready)return;root.dataset.ready='true';
  const copy=JSON.parse(root.querySelector('[data-gift-copy]').textContent);let opener;
  root.querySelectorAll('[data-gift-open]').forEach(button=>button.addEventListener('click',()=>{
    opener=button;
    const dialog=document.getElementById(button.dataset.giftOpen);
    if(root.dataset.birthdayCatalog==='true'){
      try{
        const draft=JSON.parse(sessionStorage.getItem('hj-birthday-gift-note-v1')||'null');
        if(draft&&Date.now()-Number(draft.updated||0)<7200000){
          const form=dialog.querySelector('form');
          [['Gift to',draft.to],['Gift from',draft.from],['Gift message',draft.message]].forEach(([name,value])=>{
            const field=form.elements.namedItem('properties['+name+']');
            if(field){field.disabled=false;field.value=String(value||'').slice(0,name==='Gift message'?300:60);field.dispatchEvent(new Event('input',{bubbles:true}));}
          });
          const toggle=form.elements.namedItem('properties[Send as a gift]');
          if(toggle){toggle.checked=true;toggle.dispatchEvent(new Event('change',{bubbles:true}));}
        }
      }catch(error){}
    }
    dialog.showModal();
  }));
  root.querySelectorAll('dialog').forEach(dialog=>{
    dialog.querySelector('[data-gift-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('close',()=>opener?.focus({preventScroll:true}));
    dialog.addEventListener('click',event=>{if(event.target===dialog){const b=dialog.getBoundingClientRect();if(event.clientX<b.left||event.clientX>b.right||event.clientY<b.top||event.clientY>b.bottom)dialog.close();}});
    const form=dialog.querySelector('form'),status=form.querySelector('[data-gift-status]'),submit=form.querySelector('[type="submit"]');
    const preview=form.querySelector('[data-note-preview]');
    const noteFields=['Gift to','Gift message','Gift from'].map(name=>form.elements.namedItem('properties['+name+']'));
    const previewNodes=['[data-preview-to]','[data-preview-message]','[data-preview-from]'].map(selector=>preview.querySelector(selector));
    function updateNotePreview(){
      const values=noteFields.map(field=>field.value.trim());
      preview.hidden=!values.some(Boolean);
      previewNodes.forEach((node,index)=>{node.textContent=values[index];node.hidden=!values[index];});
    }
    noteFields.forEach(field=>field.addEventListener('input',updateNotePreview));
    dialog.addEventListener('toggle',updateNotePreview);
    updateNotePreview();
    form.addEventListener('change',event=>{if(event.target.name==='id'){form.querySelector('[data-gift-price-amount]').textContent=event.target.dataset.price;const priceWas=form.querySelector('[data-gift-price-was]');if(priceWas)priceWas.textContent=event.target.dataset.priceWas||'';const saving=event.target.dataset.saving||'',reveal=form.querySelector('[data-gift-saving]');if(saving)form.querySelector('[data-gift-saving-text]').textContent=saving;reveal.classList.toggle('is-visible',Boolean(saving));reveal.setAttribute('aria-hidden',String(!saving));status.textContent='';}});
    form.addEventListener('submit',async event=>{
      event.preventDefault();if(submit.disabled)return;
      let added=false;
      submit.disabled=true;submit.textContent=copy.adding;status.textContent='';
      try{
        const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});
        const data=await response.json();if(!response.ok)throw new Error(copy.error);
        added=true;if(root.dataset.birthdayCatalog==='true'){try{sessionStorage.removeItem('hj-birthday-gift-note-v1')}catch(error){}}window.location.assign(root.dataset.cartUrl);
      }catch(error){status.textContent=copy.error;}
      finally{if(!added){submit.disabled=false;submit.textContent=copy.add;}}
    });
  });
}
document.querySelectorAll('[data-hj-gifting]').forEach(initHJGiftPage);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-gifting]').forEach(initHJGiftPage));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shared-video-gallery"] && !Shopify.designMode) return;
  try {
    
function initHJSharedVideos(root){
  if(root.dataset.ready)return;
  root.dataset.ready='true';
  const videos=[...root.querySelectorAll('video')],visible=new Set(),pending=new Set();
  const reduced=matchMedia('(prefers-reduced-motion: reduce)');
  let disposed=false,loadingAllowed=false,idleHandle;
  const nearby=new Set();
  function load(video){
    if(disposed||!loadingAllowed||document.hidden||document.documentElement.classList.contains('hj-age-gate-open')||!nearby.has(video)||video.dataset.loaded)return;
    video.querySelectorAll('source[data-src]').forEach(source=>{
      source.src=source.dataset.src;
      source.removeAttribute('data-src');
    });
    video.dataset.loaded='true';
    video.preload='metadata';
    video.load();
  }
  function allowLoading(){
    if(disposed)return;
    loadingAllowed=true;
    resume();
  }
  function afterLoad(){
    if('requestIdleCallback' in window)idleHandle=window.requestIdleCallback(allowLoading,{timeout:3000});
    else idleHandle=window.setTimeout(allowLoading,500);
  }
  if(document.readyState==='complete')afterLoad();
  else window.addEventListener('load',afterLoad,{once:true});
  const loadObserver=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting)nearby.add(entry.target);else nearby.delete(entry.target);
      load(entry.target);
      play(entry.target);
    });
  },{rootMargin:'400px 0px'});
  function play(video){
    if(disposed)return;
    if(!video.dataset.loaded)return;
    if(document.hidden||reduced.matches||document.documentElement.classList.contains('hj-age-gate-open')||!visible.has(video)){video.pause();return}
    if(!video.paused||pending.has(video))return;
    video.muted=true;video.defaultMuted=true;video.playsInline=true;
    pending.add(video);
    video.play().catch(error=>{
      if(error.name==='NotAllowedError'&&!disposed)video.controls=true;
    }).finally(()=>pending.delete(video));
  }
  function resume(){videos.forEach(video=>{load(video);play(video)})}
  function ready(event){play(event.currentTarget)}
  function playing(event){event.currentTarget.controls=false}
  const observer=new IntersectionObserver(entries=>{
    entries.forEach(entry=>{
      if(entry.isIntersecting)visible.add(entry.target);else visible.delete(entry.target);
      play(entry.target);
    });
  });
  videos.forEach(video=>{
    video.muted=true;video.defaultMuted=true;video.playsInline=true;
    video.addEventListener('loadeddata',ready);
    video.addEventListener('canplay',ready);
    video.addEventListener('playing',playing);
    observer.observe(video);
    loadObserver.observe(video);
  });
  document.addEventListener('hj:age-verified',resume);
  document.addEventListener('visibilitychange',resume);
  document.addEventListener('touchend',resume,{passive:true});
  document.addEventListener('click',resume);
  window.addEventListener('pageshow',resume);
  reduced.addEventListener('change',resume);
  root.cleanup=()=>{
    disposed=true;observer.disconnect();loadObserver.disconnect();
    window.removeEventListener('load',afterLoad);
    if('cancelIdleCallback' in window)window.cancelIdleCallback(idleHandle);else window.clearTimeout(idleHandle);
    document.removeEventListener('hj:age-verified',resume);
    document.removeEventListener('visibilitychange',resume);
    document.removeEventListener('touchend',resume);
    document.removeEventListener('click',resume);
    window.removeEventListener('pageshow',resume);
    reduced.removeEventListener('change',resume);
    videos.forEach(video=>{
      video.removeEventListener('loadeddata',ready);
      video.removeEventListener('canplay',ready);
      video.removeEventListener('playing',playing);
      video.pause();
    });
  };
}
document.querySelectorAll('[data-hj-shared-videos]').forEach(initHJSharedVideos);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-shared-videos]').forEach(initHJSharedVideos));
document.addEventListener('shopify:section:unload',event=>event.target.querySelectorAll('[data-hj-shared-videos]').forEach(root=>root.cleanup?.()));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-the-range"] && !Shopify.designMode) return;
  try {
    

function initHJRangeTitleFit(section){
  if(section.classList.contains('hj-range--catalog'))return;
  const titles=[...section.querySelectorAll('.hj-card__body h3')];
  const mobile=window.matchMedia('(max-width:749px)');
  function fit(title){
    title.style.removeProperty('letter-spacing');
    if(!mobile.matches||!title.getBoundingClientRect().width)return;
    const lineHeight=parseFloat(getComputedStyle(title).lineHeight);
    for(let step=1;step<=12&&title.getBoundingClientRect().height>lineHeight*2+1;step++){
      title.style.letterSpacing=(-step*0.005)+'em';
    }
  }
  let frame;
  function schedule(){
    cancelAnimationFrame(frame);
    frame=requestAnimationFrame(()=>titles.forEach(fit));
  }
  const widths=new WeakMap();
  const observer=new ResizeObserver(entries=>{
    let changed=false;
    entries.forEach(entry=>{
      const width=entry.contentRect.width;
      if(widths.get(entry.target)!==width){widths.set(entry.target,width);changed=true}
    });
    if(changed)schedule();
  });
  titles.forEach(title=>observer.observe(title));
  mobile.addEventListener('change',schedule);
  if(document.fonts)document.fonts.ready.then(schedule);
  schedule();
  document.addEventListener('shopify:section:unload',function cleanup(event){
    if(!event.target.contains(section))return;
    observer.disconnect();
    cancelAnimationFrame(frame);
    mobile.removeEventListener('change',schedule);
    document.removeEventListener('shopify:section:unload',cleanup);
  });
}


function initHJRange(section){if(section.dataset.ready)return;section.dataset.ready='true';initHJRangeTitleFit(section);const tabs=[...section.querySelectorAll('[data-range-tab]')],indicator=section.querySelector('.hj-range__indicator');function positionIndicator(tab){if(!tab||!indicator)return;indicator.style.width=tab.offsetWidth+'px';indicator.style.transform='translateX('+(tab.offsetLeft-section.querySelector('.hj-range__tabs').scrollLeft)+'px)'}function activate(tab){if(tab.classList.contains('is-active'))return;const current=section.querySelector('.hj-range__panel.is-active'),next=section.querySelector('[data-range-panel="'+tab.dataset.rangeTab+'"]');tabs.forEach(item=>{const active=item===tab;item.classList.toggle('is-active',active);item.setAttribute('aria-selected',active)});positionIndicator(tab);current.classList.add('is-leaving');setTimeout(()=>{current.hidden=true;current.classList.remove('is-active','is-leaving');next.hidden=false;next.classList.add('is-active','is-preparing');requestAnimationFrame(()=>requestAnimationFrame(()=>next.classList.remove('is-preparing')))},280)}const requestedTab=new URLSearchParams(window.location.search).get('tab');const tabCollections={single:'single-flavour',mixed:'mixed-flavour',variety:'all-flavours-packs',popular:'popular'};const requestedCollection=tabCollections[requestedTab]||requestedTab;const linkedTab=tabs.find(tab=>tab.dataset.rangeCollection===requestedCollection)||tabs.find(tab=>tab.dataset.rangeTab===requestedTab);if(linkedTab){tabs.forEach(tab=>{const selected=tab===linkedTab;tab.classList.toggle('is-active',selected);tab.setAttribute('aria-selected',String(selected))});section.querySelectorAll('[data-range-panel]').forEach(panel=>{const selected=panel.dataset.rangePanel===linkedTab.dataset.rangeTab;panel.hidden=!selected;panel.classList.toggle('is-active',selected)});}tabs.forEach(tab=>tab.addEventListener('click',()=>activate(tab)));window.addEventListener('resize',()=>positionIndicator(section.querySelector('.hj-range__tab.is-active')));positionIndicator(section.querySelector('.hj-range__tab.is-active'));section.querySelectorAll('.hj-card__form').forEach(form=>{const price=form.querySelector('[data-card-price]'),shipping=price.querySelector('em')?.textContent||'';form.addEventListener('change',event=>{if(event.target.name!=='id')return;form.querySelectorAll('.hj-card__variant').forEach(label=>label.classList.toggle('is-selected',label.querySelector('input').checked));const chosen=event.target.closest('.hj-card__variant'),value=chosen.dataset.price,amount=value.slice(0,value.length-shipping.length).trim();const was=price.querySelector('[data-retail-price-was]');if(was)was.textContent=chosen.dataset.priceWas||'';window.HJTransitionPrice(price,amount,chosen.dataset.priceCents);const saving=form.querySelector('[data-card-saving-display]');if(saving){const text=event.target.closest('.hj-card__variant').dataset.cardSaving||'',reveal=saving.closest('[data-saving-reveal]');if(text)saving.querySelector('[data-saving-amount]').textContent=text;reveal.classList.toggle('is-visible',Boolean(text));reveal.setAttribute('aria-hidden',String(!text))}});form.addEventListener('submit',async event=>{event.preventDefault();const button=form.querySelector('button[type="submit"]');button.disabled=true;try{const response=await fetch('/cart/add.js',{method:'POST',headers:{Accept:'application/json'},body:new FormData(form)});if(!response.ok)throw new Error();await response.json();await window.HJCart.getCart();window.HJCart.open()}catch(error){button.textContent='Try again';setTimeout(()=>button.textContent='Add to Cart',1800)}finally{button.disabled=false}})})}document.querySelectorAll('[data-hj-range]').forEach(initHJRange);document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-range]').forEach(initHJRange));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shot-statistics"] && !Shopify.designMode) return;
  try {
    
function formatHJShotStats(root){root.querySelectorAll('[data-stat-number]').forEach(el=>{if(el.dataset.formatted)return;const n=Number(el.textContent);if(Number.isFinite(n)){el.textContent=new Intl.NumberFormat('en-GB',{maximumFractionDigits:5}).format(n);el.dataset.formatted='true'}})}
document.querySelectorAll('[data-shot-stats]').forEach(formatHJShotStats);
document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-shot-stats]').forEach(formatHJShotStats));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shots-served-features"] && !Shopify.designMode) return;
  try {
    
function initHJServedFeatures(root){
  if(root.dataset.motionReady)return;
  root.dataset.motionReady='true';
  root.querySelectorAll('.hj-served__feature').forEach(feature=>{
    feature.addEventListener('mouseenter',()=>feature.classList.remove('is-returning'));
    feature.addEventListener('mouseleave',()=>{
      feature.classList.remove('is-returning');
      requestAnimationFrame(()=>feature.classList.add('is-returning'));
    });
    feature.addEventListener('animationend',event=>{
      if(event.animationName==='hj-served-return')feature.classList.remove('is-returning');
    });
  });
}
document.querySelectorAll('.hj-served').forEach(initHJServedFeatures);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('.hj-served').forEach(initHJServedFeatures));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-hero"] && !Shopify.designMode) return;
  try {
    

function initHJHero(root){
if(root.dataset.ready)return;root.dataset.ready='true';
const video=root.querySelector('video'),mobile=matchMedia('(max-width: 749px)'),reduced=matchMedia('(prefers-reduced-motion: reduce)');
if(video){video.muted=true;video.defaultMuted=true;video.playsInline=true;const source=mobile.matches?(root.dataset.mobile||root.dataset.desktop):(root.dataset.desktop||root.dataset.mobile);if(source)video.src=source}
let manuallyPaused=false,revealPlayed=false,revealFrame=0,videoFrameReady=false,ageVerified=!document.documentElement.classList.contains('hj-age-gate-open');
const reveal=root.querySelector('.hj-video-reveal');
const hero=root.querySelector('.hj-hero');
const playButton=root.querySelector('[data-hero-play]');
let fallbackTimer=0,playPending=false,autoplayBlocked=false;
function showFallback(){
 if(!video||!ageVerified||!root.isConnected)return;
 clearTimeout(fallbackTimer);
 cancelAnimationFrame(revealFrame);
 revealPlayed=true;
 reveal?.remove();
 headerTransitionCopy?.remove();
 headerTransitionCopy=null;
 root.classList.add('hj-reveal-ready');
 if(video.paused||video.readyState<2)root.classList.remove('hj-video-playing');
 if(playButton)playButton.hidden=false;
}
function onPlaying(){
 clearTimeout(fallbackTimer);
 autoplayBlocked=false;
 root.classList.add('hj-video-playing');
 if(playButton)playButton.hidden=true;
 videoFrameReady=true;
 root.dispatchEvent(new Event('hj:run-hero-reveal'));
}
function onVideoError(){autoplayBlocked=true;showFallback()}
function attemptPlay(){
 if(playPending||!video)return;
 playPending=true;
 video.muted=true;video.defaultMuted=true;video.playsInline=true;
 video.play().catch(()=>{autoplayBlocked=true;showFallback()}).finally(()=>{playPending=false});
}
function manualPlay(){
 if(!ageVerified)return;
 manuallyPaused=false;
 autoplayBlocked=false;
 attemptPlay();
}

video?.addEventListener('playing',onPlaying);
video?.addEventListener('error',onVideoError);
playButton?.addEventListener('click',manualPlay);
const header=root.querySelector('.hj-header');
let headerTransitionCopy=null;
revealPlayed=true;
reveal?.remove();
root.classList.add('hj-reveal-ready');
const announcement=root.querySelector('[data-announcement-text]');
const messages=JSON.parse(root.querySelector('[data-announcement-messages]')?.textContent||'[]').filter(text=>typeof text==='string'&&text.trim());
let announcementTimer,announcementIndex=0,announcementAnimations=[],announcementGeneration=0;
function showAnnouncement(){
 if(!announcement||!messages.length)return;
 announcement.replaceChildren();const accessible=document.createElement('span');accessible.className='hj-sr';accessible.textContent=messages[announcementIndex];announcement.append(accessible);
 const text=messages[announcementIndex],bold=text.toUpperCase().startsWith('FREE DELIVERY')?13:0;
 Array.from(text).forEach((letter,index)=>{const span=document.createElement('span');span.className='hj-announcement-letter';span.textContent=letter;span.setAttribute('aria-hidden','true');span.style.fontWeight=index<bold?'700':'400';announcement.append(span)});
}
function fadeAnnouncement(out){
 const letters=[...announcement.querySelectorAll('.hj-announcement-letter')],spread=320;
 announcementAnimations=letters.map((letter,index)=>letter.animate([{opacity:out?1:0},{opacity:out?0:1}],{duration:180,delay:index*spread/Math.max(1,letters.length-1),fill:'both',easing:'ease-in-out'}));
 return Promise.all(announcementAnimations.map(animation=>animation.finished.catch(()=>{})));
}
async function cycleAnnouncement(){
 const generation=announcementGeneration;
 if(generation!==announcementGeneration||!root.isConnected||document.hidden||reduced.matches)return;
 await fadeAnnouncement(true);if(generation!==announcementGeneration||!root.isConnected||document.hidden||reduced.matches)return;
 announcementAnimations.forEach(animation=>animation.cancel());announcementIndex=(announcementIndex+1)%messages.length;showAnnouncement();
 await fadeAnnouncement(false);if(generation!==announcementGeneration||!root.isConnected||document.hidden||reduced.matches)return;
 announcementAnimations.forEach(animation=>animation.cancel());announcementTimer=setTimeout(cycleAnnouncement,3000);
}
function resetAnnouncement(){
 announcementGeneration++;
 clearTimeout(announcementTimer);announcementAnimations.forEach(animation=>animation.cancel());announcementIndex=0;showAnnouncement();
 const isHomepage=root.dataset.homepage==='true';
 if(!isHomepage&&announcement&&messages.length>1&&!reduced.matches&&!document.hidden)announcementTimer=setTimeout(cycleAnnouncement,3000);
}
resetAnnouncement();document.addEventListener('visibilitychange',resetAnnouncement);reduced.addEventListener('change',resetAnnouncement);
function load(){
 if(!video||!root.isConnected)return;
 if(ageVerified&&!document.hidden&&!reduced.matches&&!manuallyPaused){
  if(!fallbackTimer&&!root.classList.contains('hj-video-playing'))fallbackTimer=setTimeout(showFallback,1800);
  if(!autoplayBlocked)attemptPlay();
 }else{
  video.pause();
  if(ageVerified&&reduced.matches)showFallback();
 }
}
function reloadResponsiveVideo(){if(!video)return;autoplayBlocked=false;root.classList.remove('hj-video-playing');const source=mobile.matches?(root.dataset.mobile||root.dataset.desktop):(root.dataset.desktop||root.dataset.mobile);if(!source||video.getAttribute('src')===source)return;video.pause();videoFrameReady=false;video.src=source;video.load();if(video.readyState>=2){videoFrameReady=true}load()}
function enterSite(){
  ageVerified=true;
  load();
  if(video?.readyState>=2)videoFrameReady=true;
  const revealNow=()=>{
    if(videoFrameReady){
      const evt=new Event('hj:run-hero-reveal');
      root.dispatchEvent(evt);
    }
  };
  revealNow();
}
mobile.addEventListener('change',reloadResponsiveVideo);reduced.addEventListener('change',load);
document.addEventListener('hj:age-verified',enterSite,{once:true});
video?.addEventListener('canplay',load);
document.addEventListener('visibilitychange',load);

window.addEventListener('pageshow',load);
const search=root.querySelector('.hj-search'),actions=root.querySelector('.hj-actions'),searchForm=root.querySelector('.hj-search-form'),searchClose=root.querySelector('.hj-search-close');search.addEventListener('click',()=>{actions.classList.add('search-open');search.setAttribute('aria-expanded','true');searchForm.querySelector('input').focus()});function closeSearch(){actions.classList.remove('search-open');search.setAttribute('aria-expanded','false')}searchClose.addEventListener('click',closeSearch);searchForm.addEventListener('keydown',e=>{if(e.key==='Escape')closeSearch()});const dialog=root.querySelector('dialog'),toggle=root.querySelector('.hj-menu-toggle');toggle.addEventListener('click',()=>{dialog.showModal();toggle.setAttribute('aria-expanded','true')});root.querySelector('.hj-close').addEventListener('click',()=>dialog.close());dialog.addEventListener('close',()=>{toggle.setAttribute('aria-expanded','false');toggle.focus()});dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX>r.right||e.clientX<r.left)dialog.close()}});load();
root.cleanup=()=>{clearTimeout(fallbackTimer);video?.removeEventListener('playing',onPlaying);video?.removeEventListener('error',onVideoError);playButton?.removeEventListener('click',manualPlay);announcementGeneration++;clearTimeout(announcementTimer);announcementAnimations.forEach(animation=>animation.cancel());cancelAnimationFrame(revealFrame);headerTransitionCopy?.remove();document.removeEventListener('visibilitychange',resetAnnouncement);reduced.removeEventListener('change',resetAnnouncement);mobile.removeEventListener('change',reloadResponsiveVideo);reduced.removeEventListener('change',load);document.removeEventListener('hj:age-verified',enterSite);video?.removeEventListener('canplay',load);document.removeEventListener('visibilitychange',load);document.removeEventListener('touchend',load);document.removeEventListener('click',load);window.removeEventListener('pageshow',load);video?.pause()};
load();
}
function initHJLogoMotion(root){const items=[root.querySelector('.hj-pick')].filter(Boolean);items.forEach(item=>{if(item.dataset.motionReady)return;item.dataset.motionReady='true';item.addEventListener('mouseenter',()=>item.classList.remove('is-returning'));item.addEventListener('mouseleave',()=>{item.classList.remove('is-returning');requestAnimationFrame(()=>item.classList.add('is-returning'))});item.addEventListener('animationend',event=>{if(event.animationName==='hj-logo-return'||event.animationName==='hj-button-half-return')item.classList.remove('is-returning')})})}document.querySelectorAll('[data-hj-hero]').forEach(root=>{initHJHero(root);initHJLogoMotion(root)});document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-hj-hero]').forEach(root=>{initHJHero(root);initHJLogoMotion(root)}));document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-hj-hero]').forEach(r=>r.cleanup?.()));

function initHJInfoMenu(scope){
  scope.querySelectorAll('[data-hj-hero]').forEach(root=>{
    const trigger=root.querySelector('.hj-info-trigger'),banner=root.querySelector('.hj-info-banner');
    if(!trigger||!banner||trigger.dataset.infoReady)return;
    trigger.dataset.infoReady='true';
    let timer;
    const links=banner.querySelector('.hj-info-links');
    function fitLinks(){
      if(!links.clientWidth)return;
      let size=Math.min(15,innerWidth*.015);
      links.style.fontSize=size+'px';
      const available=links.clientWidth-24;
      const width=()=>[...links.children].reduce((sum,item)=>sum+item.getBoundingClientRect().width,0);
      while(width()>available&&size>1){size-=.25;links.style.fontSize=size+'px'}
    }
    new ResizeObserver(fitLinks).observe(links);
    document.fonts?.ready.then(fitLinks);
    fitLinks();
    const setOpen=open=>{clearTimeout(timer);trigger.setAttribute('aria-expanded',String(open));banner.classList.toggle('is-open',open);banner.inert=!open;if(open)fitLinks()};
    const closeSoon=()=>{timer=setTimeout(()=>setOpen(false),160)};
    [trigger,banner].forEach(node=>{
      node.addEventListener('pointerenter',event=>{if(event.pointerType==='mouse')setOpen(true)});
      node.addEventListener('focusin',()=>{if(node===banner||trigger.matches(':focus-visible'))setOpen(true)});
      node.addEventListener('focusout',event=>{if(!banner.contains(event.relatedTarget)&&event.relatedTarget!==trigger)closeSoon()});
    });
    trigger.addEventListener('click',event=>setOpen(event.pointerType==='mouse'?true:!banner.classList.contains('is-open')));
    root.addEventListener('keydown',event=>{if(event.key==='Escape'&&banner.classList.contains('is-open')){trigger.focus();setOpen(false)}});
    document.addEventListener('pointermove',event=>{
      if(event.pointerType!=='mouse'||!banner.classList.contains('is-open'))return;
      const bottom=banner.getBoundingClientRect().top+links.scrollHeight;
      if(event.clientY>bottom)setOpen(false);
    },{passive:true});
    document.addEventListener('pointerdown',event=>{if(event.pointerType!=='mouse'&&!banner.contains(event.target)&&!trigger.contains(event.target))setOpen(false)});
  });
}
initHJInfoMenu(document);
document.addEventListener('shopify:section:load',event=>initHJInfoMenu(event.target));

function initHJHeroShop(root){
  const panel=root.querySelector('.hj-hero-shop'),hero=root.querySelector('.hj-hero');
  if(!panel||!hero||panel.dataset.scrollReady)return;
  panel.dataset.scrollReady='true';
  document.body.append(panel);
  const button=panel.querySelector('a');
  button.addEventListener('click',event=>{
    const target=document.getElementById('shop-the-shots');
    if(!target)return;
    event.preventDefault();
    target.focus({preventScroll:true});
    target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth',block:'start'});
  });
  let frame=0;
  function update(){
    frame=0;
    const heading=document.querySelector('#shop-the-shots h2');
    const headingRect=heading?.getBoundingClientRect();
    const headingVisible=headingRect&&headingRect.bottom>0&&headingRect.top<window.innerHeight;
    const rect=hero.getBoundingClientRect();
    const opacity=headingVisible?0:Math.max(0,Math.min(1,1-Math.max(0,-rect.top)/Math.max(1,rect.height*.65)));
    panel.style.opacity=String(opacity);
    const hidden=opacity<.05;
    panel.style.visibility=hidden?'hidden':'visible';
    panel.style.pointerEvents=hidden?'none':'';
    panel.setAttribute('aria-hidden',String(hidden));
    if(hidden)button.setAttribute('tabindex','-1');else button.removeAttribute('tabindex');
  }
  function schedule(){if(!frame)frame=requestAnimationFrame(update)}
  window.addEventListener('scroll',schedule,{passive:true});
  window.addEventListener('resize',schedule);
  window.addEventListener('load',schedule,{once:true});
  update();
  document.addEventListener('shopify:section:unload',event=>{
    if(event.target.contains(root)){
      window.removeEventListener('scroll',schedule);
      window.removeEventListener('resize',schedule);
      window.removeEventListener('load',schedule);
      cancelAnimationFrame(frame);
      panel.remove();
    }
  });
}
document.querySelectorAll('[data-hj-hero]').forEach(initHJHeroShop);
document.addEventListener('shopify:section:load',event=>event.target.querySelectorAll('[data-hj-hero]').forEach(initHJHeroShop));

  } catch(e) { console.error(e); }
})();
})();
